export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string
  String: string
  Boolean: boolean
  Int: number
  Float: number
  /** The javascript `Date` as string. Type represents date and time as the ISO Date string. */
  DateTime: any
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: any
  ServiceUids: any
}

export type AbortCourtCaseInput = {
  abortReason: Scalars['String']
  courtCaseUuid: Scalars['ID']
}

export type AddMembersToUserGroupInput = {
  groupId: Scalars['Int']
  members: Array<UserGroupMemberInput>
}

export type AddPrincipalsInput = {
  powerOfAttorneyUid: Scalars['String']
  principals: Array<PrincipalInput>
}

export type AddPurchaseInput = {
  customerId: Scalars['Int']
  lawyerId: Scalars['Int']
  paymentMethod?: InputMaybe<PaymentMethod>
  subscriptionId: Scalars['Int']
}

export type AddReferenceNumberToInsuranceClaimInput = {
  referenceNumber: Scalars['String']
  uuid: Scalars['ID']
}

export type AddRerefenceNumberToCourtCaseInput = {
  courtCaseUuid: Scalars['ID']
  referenceNumber: Scalars['String']
}

export type AddScheduledActionInput = {
  action: Scalars['String']
  customerId: Scalars['Int']
  dueDateInDays: Scalars['Int']
}

export type AddSelfPaymentAgreementInput = {
  courtCaseCoverageRequestUuid: Scalars['ID']
  firstName: Scalars['String']
  lastName: Scalars['String']
  location: Scalars['String']
  signature: Scalars['String']
}

export type AddSpringerCustomerInput = {
  customerId: Scalars['Float']
  lawyerId: Scalars['Float']
  messageId: Scalars['Float']
}

export type AddTemplateInput = {
  description?: InputMaybe<Scalars['String']>
  fields: Array<TemplateFieldInput>
  tags?: InputMaybe<Array<Scalars['String']>>
  templateCollectionUid: Scalars['String']
  title: Scalars['String']
  uid: Scalars['String']
}

export type Address = {
  city?: InputMaybe<Scalars['String']>
  street?: InputMaybe<Scalars['String']>
  zip?: InputMaybe<Scalars['String']>
}

export type Admin = {
  __typename?: 'Admin'
  createdAt: Scalars['DateTime']
  email: Scalars['String']
  features: Array<FeatureFlag>
  firstName: Scalars['String']
  id: Scalars['Int']
  isEmailConfirmed: Scalars['Boolean']
  lastName: Scalars['String']
  updatedAt: Scalars['DateTime']
}

export type AdminsCollection = {
  __typename?: 'AdminsCollection'
  first?: Maybe<Admin>
  items: Array<Admin>
  last?: Maybe<Admin>
  skip?: Maybe<Scalars['Int']>
  take?: Maybe<Scalars['Int']>
  total: Scalars['Int']
}

export type AdminsListFilterInput = {
  email?: InputMaybe<StringFilter>
  id?: InputMaybe<IntFilter>
  isEmailConfirmed?: InputMaybe<BooleanFilter>
  lastName?: InputMaybe<StringFilter>
  userGroup?: InputMaybe<StringFilter>
}

export type AdminsListMultiSortOrderInput = {
  createdAt?: InputMaybe<Scalars['Int']>
  fullName?: InputMaybe<Scalars['Int']>
  id?: InputMaybe<Scalars['Int']>
  isEmailConfirmed?: InputMaybe<Scalars['Int']>
  lastName?: InputMaybe<Scalars['Int']>
  updatedAt?: InputMaybe<Scalars['Int']>
}

export type AdminsListSortInput = {
  createdAt?: InputMaybe<SortDirection>
  fullName?: InputMaybe<SortDirection>
  id?: InputMaybe<SortDirection>
  isEmailConfirmed?: InputMaybe<SortDirection>
  lastName?: InputMaybe<SortDirection>
  updatedAt?: InputMaybe<SortDirection>
}

export type AdvancePaymentsCheck = {
  __typename?: 'AdvancePaymentsCheck'
  conditions: Array<Condition>
  context: AdvancePaymentsContext
  name: UtilityBillCheckName
  outcome: Outcome
}

export type AdvancePaymentsContext = {
  __typename?: 'AdvancePaymentsContext'
  values: AdvancePaymentsContextValues
}

export type AdvancePaymentsContextValues = {
  __typename?: 'AdvancePaymentsContextValues'
  advancePayment?: Maybe<Scalars['Float']>
}

export type AppointmentCustomer = {
  email: Scalars['String']
  firstName: Scalars['String']
  gender?: InputMaybe<Gender>
  id: Scalars['Int']
  lastName: Scalars['String']
  membershipNumber: Scalars['String']
  phone?: InputMaybe<Scalars['String']>
}

export type AppointmentLawyer = {
  firstName: Scalars['String']
  lastName: Scalars['String']
}

export type AppointmentLead = {
  city?: InputMaybe<Scalars['String']>
  email: Scalars['String']
  firstName: Scalars['String']
  gender?: InputMaybe<Gender>
  lastName: Scalars['String']
  phone?: InputMaybe<Scalars['String']>
  street?: InputMaybe<Scalars['String']>
  zip?: InputMaybe<Scalars['String']>
}

export type AppointmentSpringer = {
  __typename?: 'AppointmentSpringer'
  lawyerLastName: Scalars['String']
  springerCustomers: Array<SpringerEntries>
}

export type ApproveMessageInput = {
  insuranceClaimServiceUuid?: InputMaybe<Scalars['ID']>
  messageId: Scalars['Int']
}

export type ArchiveCaseInput = {
  caseId: Scalars['Int']
  questionId: Scalars['Int']
}

export type ArchiveConflictOfInterestInput = {
  uuid: Scalars['ID']
}

export type ArchiveCourtCaseInput = {
  courtCaseUuid: Scalars['ID']
}

export type ArrayIntFilter = {
  contains?: InputMaybe<Array<Scalars['Int']>>
}

export type AskQuestionForCheckResultsInput = {
  checkInsuranceClaimUuid: Scalars['String']
  checkService: Scalars['ServiceUids']
  content?: InputMaybe<Scalars['String']>
  lawyerId?: InputMaybe<Scalars['Int']>
  topicName: Scalars['String']
}

export type AskQuestionInput = {
  content?: InputMaybe<Scalars['String']>
  lawyerId?: InputMaybe<Scalars['Int']>
  messageTypePreference?: InputMaybe<MessageTypePreference>
  topicId: Scalars['Int']
  topicQuestionnaireAnswers?: InputMaybe<Scalars['JSON']>
}

export type AssignAgentToSupportRequestCasesInput = {
  agentId?: InputMaybe<Scalars['Int']>
  caseIds: Array<Scalars['Int']>
}

export type AssignCasesInput = {
  adminId?: InputMaybe<Scalars['Int']>
  caseIds: Array<Scalars['Int']>
}

export type AssignCourtCasesInput = {
  adminId?: InputMaybe<Scalars['Int']>
  courtCaseIds: Array<Scalars['ID']>
}

export type AssignCourtCasesToLawyerInput = {
  courtCaseIds: Array<Scalars['ID']>
  lawyerId?: InputMaybe<Scalars['Int']>
}

export type AssignServiceTasksInput = {
  adminId?: InputMaybe<Scalars['Int']>
  serviceTaskIds: Array<Scalars['Int']>
}

export type AttachInsuranceClaimToCaseInput = {
  caseId: Scalars['Int']
  insuranceClaimUuid: Scalars['ID']
}

export type AuditReport = {
  __typename?: 'AuditReport'
  id: Scalars['Int']
  report: ProfessionalAuditReport
}

export type AuthSession = {
  __typename?: 'AuthSession'
  refreshToken: Scalars['String']
  token: Scalars['String']
}

export type BatchChangeMembershipLawyerError = {
  __typename?: 'BatchChangeMembershipLawyerError'
  customerId: Scalars['Int']
  error?: Maybe<Scalars['String']>
}

export type BatchChangeMembershipLawyerInput = {
  customerIds: Array<Scalars['Int']>
  lawyerId: Scalars['Int']
}

export type BatchChangeMembershipLawyerResult = {
  __typename?: 'BatchChangeMembershipLawyerResult'
  errors: Array<BatchChangeMembershipLawyerError>
  successfulChangesCount: Scalars['Int']
}

export type BenchmarkDeviationsCheck = {
  __typename?: 'BenchmarkDeviationsCheck'
  children: Array<BenchmarkDeviationsChildren>
  conditions: Array<Condition>
  name: UtilityBillCheckName
  outcome: Outcome
}

export type BenchmarkDeviationsChildren = {
  __typename?: 'BenchmarkDeviationsChildren'
  conditions: Array<Condition>
  context: BenchmarkDeviationsContext
  name: Scalars['String']
  outcome: Outcome
}

export type BenchmarkDeviationsContext = {
  __typename?: 'BenchmarkDeviationsContext'
  amount?: Maybe<Scalars['Float']>
  category?: Maybe<Scalars['String']>
  deviation?: Maybe<Deviation>
  increaseInPercent?: Maybe<Scalars['Float']>
  item: Scalars['String']
  prediction?: Maybe<Prediction>
  pricePerSqm?: Maybe<Scalars['Float']>
  pricePerSqmBenchmark?: Maybe<Scalars['Float']>
}

export enum BookingProvider {
  YouCanBookMe = 'YouCanBookMe'
}

export type BooleanFilter = {
  equals?: InputMaybe<Scalars['Boolean']>
  not_equals?: InputMaybe<Scalars['Boolean']>
}

export type CancelMembershipInput = {
  cancellationReason?: InputMaybe<Scalars['String']>
  endsAt: Scalars['DateTime']
  uuid: Scalars['ID']
}

export type Case = {
  __typename?: 'Case'
  answerIsOverdue: Scalars['Boolean']
  appointmentAt?: Maybe<Scalars['DateTime']>
  assignedAgent?: Maybe<Admin>
  assignedAgentId?: Maybe<Scalars['Float']>
  bookingChangeLink?: Maybe<Scalars['String']>
  bookingProvider?: Maybe<BookingProvider>
  bookingReference?: Maybe<Scalars['String']>
  customer: Customer
  customerId: Scalars['Int']
  id: Scalars['Int']
  insuranceClaim?: Maybe<InsuranceClaim>
  lastTransitionAt?: Maybe<Scalars['DateTime']>
  lawyer?: Maybe<Lawyer>
  lawyerId?: Maybe<Scalars['Int']>
  messageTypePreference?: Maybe<MessageTypePreference>
  messages: Array<Message>
  origin?: Maybe<Scalars['String']>
  purchase: Purchase
  purchaseId: Scalars['Int']
  state: CaseState
  topic: Topic
  topicId: Scalars['Int']
  updatedAt?: Maybe<Scalars['DateTime']>
}

export enum CaseState {
  AnswerReceived = 'AnswerReceived',
  Approved = 'Approved',
  Closed = 'Closed',
  Deleted = 'Deleted',
  Draft = 'Draft',
  InformationRequested = 'InformationRequested',
  PreApproved = 'PreApproved',
  QuestionAsked = 'QuestionAsked',
  Ready = 'Ready'
}

export type CaseStateFilter = {
  equals?: InputMaybe<CaseState>
  in?: InputMaybe<Array<CaseState>>
  not_equals?: InputMaybe<CaseState>
  not_in?: InputMaybe<Array<CaseState>>
}

export type CasesCollection = {
  __typename?: 'CasesCollection'
  first?: Maybe<Case>
  items: Array<Case>
  last?: Maybe<Case>
  skip?: Maybe<Scalars['Int']>
  take?: Maybe<Scalars['Int']>
  total: Scalars['Int']
}

export type CasesListFilterInput = {
  activeOnly?: InputMaybe<BooleanFilter>
  appointmentAt?: InputMaybe<DateFilter>
  assignedAgentId?: InputMaybe<IntFilter>
  createdAt?: InputMaybe<DateFilter>
  customerId?: InputMaybe<IntFilter>
  hasAppointment?: InputMaybe<BooleanFilter>
  hasPendingLetterRequest?: InputMaybe<BooleanFilter>
  id?: InputMaybe<IntFilter>
  lastTransitionAt?: InputMaybe<DateFilter>
  latestQuestionApprovedAt?: InputMaybe<DateFilter>
  lawyerId?: InputMaybe<IntFilter>
  messageTypePreference?: InputMaybe<MessageTypePreferenceFilter>
  origin?: InputMaybe<StringFilter>
  productName?: InputMaybe<StringFilter>
  state?: InputMaybe<CaseStateFilter>
  topicId?: InputMaybe<IntFilter>
  topicName?: InputMaybe<StringFilter>
  updatedAt?: InputMaybe<DateFilter>
}

export type CasesListSortInput = {
  appointmentAt?: InputMaybe<SortDirection>
  createdAt?: InputMaybe<SortDirection>
  lastTransitionAt?: InputMaybe<SortDirection>
  latestQuestionApprovedAt?: InputMaybe<SortDirection>
  updatedAt?: InputMaybe<SortDirection>
}

export type ChangeMembershipLawyerInput = {
  lawyerId: Scalars['Int']
  uuid: Scalars['ID']
}

export type ChangeMembershipNumberInput = {
  membershipNumber: Scalars['String']
  uuid: Scalars['ID']
}

export type ChatChronicItem = {
  __typename?: 'ChatChronicItem'
  id: Scalars['Int']
  item: ChatChronicItemUnion
  type: ChatChronicItemType
}

export enum ChatChronicItemType {
  Event = 'event',
  Message = 'message'
}

export type ChatChronicItemUnion = CourtCaseEvent | Message

export type CheckIfServiceIsUsableInput = {
  serviceUid: Scalars['String']
  topic?: InputMaybe<Scalars['String']>
}

export type CheckIfServiceIsUsableResult = {
  __typename?: 'CheckIfServiceIsUsableResult'
  usable: Scalars['Boolean']
  usableAgainOn?: Maybe<Scalars['DateTime']>
}

export type Checks = {
  __typename?: 'Checks'
  advancePayments: AdvancePaymentsCheck
  benchmarkDeviations: BenchmarkDeviationsCheck
  contentRequirements: ContentRequirementsCheck
  deadlines: DeadlinesCheck
  distributionFormula: DistributionFormulaCheck
  formalRequirements: FormalRequirementsCheck
  invoiceItems: InvoiceItemsCheck
  servicePeriod: ServicePeriodCheck
}

export type ClauseSpan = {
  __typename?: 'ClauseSpan'
  page?: Maybe<Scalars['Float']>
  text?: Maybe<Scalars['String']>
}

export type Condition = {
  __typename?: 'Condition'
  name: Scalars['String']
  outcome: Outcome
  reason?: Maybe<Scalars['String']>
}

export type ConflictOfInterest = {
  __typename?: 'ConflictOfInterest'
  admin: Admin
  adminId: Scalars['Int']
  archived: Scalars['Boolean']
  createdAt: Scalars['DateTime']
  customer: Customer
  customerId: Scalars['Int']
  reporter: Admin
  reporterId: Scalars['Int']
  updatedAt: Scalars['DateTime']
  uuid: Scalars['ID']
}

export type ConflictsOfInterestCollection = {
  __typename?: 'ConflictsOfInterestCollection'
  first?: Maybe<ConflictOfInterest>
  items: Array<ConflictOfInterest>
  last?: Maybe<ConflictOfInterest>
  skip?: Maybe<Scalars['Int']>
  take?: Maybe<Scalars['Int']>
  total: Scalars['Int']
}

export type ConflictsOfInterestListFilterInput = {
  adminId?: InputMaybe<IntFilter>
  archived?: InputMaybe<BooleanFilter>
  createdAt?: InputMaybe<DateFilter>
  customerId?: InputMaybe<IntFilter>
  reporterId?: InputMaybe<IntFilter>
  updatedAt?: InputMaybe<DateFilter>
  uuid?: InputMaybe<StringFilter>
}

export type ConflictsOfInterestListSortInput = {
  createdAt?: InputMaybe<SortDirection>
  updatedAt?: InputMaybe<SortDirection>
}

export type ContentRequirementsCheck = {
  __typename?: 'ContentRequirementsCheck'
  conditions: Array<Condition>
  name: UtilityBillCheckName
  outcome: Outcome
}

export type Conversation = {
  __typename?: 'Conversation'
  status?: Maybe<ConversationStatus>
}

export enum ConversationStatus {
  Answered = 'Answered',
  Approved = 'Approved',
  Checked = 'Checked',
  Draft = 'Draft',
  Empty = 'Empty',
  Sent = 'Sent'
}

export type CourtCase = {
  __typename?: 'CourtCase'
  adminDeadline?: Maybe<Scalars['DateTime']>
  adminNote?: Maybe<Scalars['String']>
  archived: Scalars['Boolean']
  assignedAgent?: Maybe<Admin>
  assignedAgentId?: Maybe<Scalars['Int']>
  assignedAt?: Maybe<Scalars['DateTime']>
  assignedLawyer?: Maybe<Lawyer>
  assignedLawyerId?: Maybe<Scalars['Int']>
  chatChronic: Array<ChatChronicItem>
  courtCaseCoverageRequest?: Maybe<CourtCaseCoverageRequest>
  createdAt: Scalars['DateTime']
  customer: Customer
  customerId: Scalars['Int']
  documents: Array<Document>
  events: CourtCaseEventsCollection
  insuranceClaim?: Maybe<InsuranceClaim>
  insuranceClaimUuid?: Maybe<Scalars['ID']>
  lawyerDocuments?: Maybe<Array<LawyerDocument>>
  membershipTypeUid: Scalars['ID']
  messages: MessagesCollection
  ongoing?: Maybe<Scalars['Boolean']>
  paymentEvents: CourtCasePaymentEventsCollection
  referenceNumber?: Maybe<Scalars['String']>
  reporter?: Maybe<Reporter>
  state: CourtCaseState
  topic: Topic
  topicId: Scalars['Int']
  upcomingAppointment?: Maybe<Scalars['DateTime']>
  upcomingDeadline?: Maybe<Scalars['DateTime']>
  updatedAt: Scalars['DateTime']
  uuid: Scalars['ID']
}

export type CourtCaseEventsArgs = {
  filters: CourtCaseEventsListFilterInput
  pagination?: InputMaybe<PaginationInput>
  sorts?: InputMaybe<CourtCaseEventsListSortInput>
}

export type CourtCaseMessagesArgs = {
  filters: MessagesListFilterInput
  pagination?: InputMaybe<PaginationInput>
  sorts?: InputMaybe<MessagesListSortInput>
}

export type CourtCasePaymentEventsArgs = {
  filters: CourtCasePaymentEventsListFilterInput
  pagination?: InputMaybe<PaginationInput>
  sorts?: InputMaybe<CourtCasePaymentEventsListSortInput>
}

export enum CourtCaseCostBearer {
  Customer = 'Customer',
  InsuranceCompany = 'InsuranceCompany'
}

export type CourtCaseCostBearerFilter = {
  equals?: InputMaybe<CourtCaseCostBearer>
  in?: InputMaybe<Array<CourtCaseCostBearer>>
  not_equals?: InputMaybe<CourtCaseCostBearer>
  not_in?: InputMaybe<Array<CourtCaseCostBearer>>
}

export type CourtCaseCoverageRequest = {
  __typename?: 'CourtCaseCoverageRequest'
  costBearer?: Maybe<CourtCaseCostBearer>
  courtCase?: Maybe<CourtCase>
  courtCaseUuid: Scalars['ID']
  createdAt: Scalars['DateTime']
  customerId: Scalars['Int']
  insuranceCoverageState?: Maybe<CourtCaseCoverageState>
  isFinal: Scalars['Boolean']
  selfPaymentAgreementDocument?: Maybe<CustomerDocument>
  selfPaymentCoverageState?: Maybe<CourtCaseCoverageState>
  updatedAt: Scalars['DateTime']
  uuid: Scalars['ID']
}

export type CourtCaseCoverageRequestsListFilterInput = {
  costBearer?: InputMaybe<CourtCaseCostBearerFilter>
  courtCaseUuid?: InputMaybe<StringFilter>
  customerId?: InputMaybe<IntFilter>
  insuranceCoverageState?: InputMaybe<CourtCaseCoverageStateFilter>
  isFinal?: InputMaybe<BooleanFilter>
  selfPaymentCoverageState?: InputMaybe<CourtCaseCoverageStateFilter>
  uuid?: InputMaybe<StringFilter>
}

export enum CourtCaseCoverageState {
  Approved = 'Approved',
  Pending = 'Pending',
  Rejected = 'Rejected'
}

export type CourtCaseCoverageStateFilter = {
  equals?: InputMaybe<CourtCaseCoverageState>
  in?: InputMaybe<Array<CourtCaseCoverageState>>
  not_equals?: InputMaybe<CourtCaseCoverageState>
  not_in?: InputMaybe<Array<CourtCaseCoverageState>>
}

export type CourtCaseEvent = {
  __typename?: 'CourtCaseEvent'
  archived: Scalars['Boolean']
  courtCaseUuid?: Maybe<Scalars['ID']>
  createdAt: Scalars['DateTime']
  customerId?: Maybe<Scalars['Int']>
  date?: Maybe<Scalars['DateTime']>
  description?: Maybe<Scalars['String']>
  initiatorRole: UserRole
  lawyerId?: Maybe<Scalars['Int']>
  metadata?: Maybe<Scalars['JSON']>
  title?: Maybe<Scalars['String']>
  type: CourtCaseEventType
  updatedAt: Scalars['DateTime']
  uuid: Scalars['ID']
}

export type CourtCaseEventInput = {
  archived?: InputMaybe<Scalars['Boolean']>
  courtCaseUuid?: InputMaybe<Scalars['ID']>
  customerId?: InputMaybe<Scalars['Int']>
  date?: InputMaybe<Scalars['DateTime']>
  description?: InputMaybe<Scalars['String']>
  lawyerId?: InputMaybe<Scalars['Int']>
  metadata?: InputMaybe<Scalars['JSON']>
  title?: InputMaybe<Scalars['String']>
  type?: InputMaybe<CourtCaseEventType>
  uuid?: InputMaybe<Scalars['ID']>
}

export enum CourtCaseEventType {
  Aborted = 'Aborted',
  Appointment = 'Appointment',
  ClientFileApproved = 'ClientFileApproved',
  CourtCaseClosed = 'CourtCaseClosed',
  CourtCaseReopened = 'CourtCaseReopened',
  CourtCaseStarted = 'CourtCaseStarted',
  CourtSession = 'CourtSession',
  Deadline = 'Deadline'
}

export type CourtCaseEventsCollection = {
  __typename?: 'CourtCaseEventsCollection'
  first?: Maybe<CourtCaseEvent>
  items: Array<CourtCaseEvent>
  last?: Maybe<CourtCaseEvent>
  skip?: Maybe<Scalars['Int']>
  take?: Maybe<Scalars['Int']>
  total: Scalars['Int']
}

export type CourtCaseEventsListFilterInput = {
  courtCaseUuid?: InputMaybe<StringFilter>
  date?: InputMaybe<DateFilter>
  ignoreAppointmentsFollowedByLawyerMessage?: InputMaybe<BooleanFilter>
  includeArchived?: InputMaybe<BooleanFilter>
  source?: InputMaybe<StringFilter>
  type?: InputMaybe<StringFilter>
}

export type CourtCaseEventsListSortInput = {
  createdAt?: InputMaybe<SortDirection>
  date?: InputMaybe<SortDirection>
  updatedAt?: InputMaybe<SortDirection>
}

export type CourtCaseMessageInput = {
  content?: InputMaybe<Scalars['String']>
  courtCaseUuid?: InputMaybe<Scalars['ID']>
  customerId?: InputMaybe<Scalars['Int']>
  id?: InputMaybe<Scalars['Int']>
  lawyerId?: InputMaybe<Scalars['Int']>
  sentAt?: InputMaybe<Scalars['DateTime']>
  topicQuestionnaireAnswers?: InputMaybe<Scalars['JSON']>
  type?: InputMaybe<MessageType>
}

export type CourtCasePaymentEvent = {
  __typename?: 'CourtCasePaymentEvent'
  archived: Scalars['Boolean']
  courtCaseUuid?: Maybe<Scalars['ID']>
  createdAt: Scalars['DateTime']
  customerId?: Maybe<Scalars['Int']>
  initiatorRole: UserRole
  invoiced: Scalars['Boolean']
  invoicedAt?: Maybe<Scalars['DateTime']>
  lawyerId?: Maybe<Scalars['Int']>
  metadata?: Maybe<Scalars['JSON']>
  payload?: Maybe<Scalars['JSON']>
  type: CourtCasePaymentEventType
  updatedAt: Scalars['DateTime']
  uuid: Scalars['ID']
}

export type CourtCasePaymentEventInput = {
  archived?: InputMaybe<Scalars['Boolean']>
  courtCaseUuid?: InputMaybe<Scalars['ID']>
  customerId?: InputMaybe<Scalars['Int']>
  invoiced?: InputMaybe<Scalars['Boolean']>
  invoicedAt?: InputMaybe<Scalars['DateTime']>
  lawyerId?: InputMaybe<Scalars['Int']>
  metadata?: InputMaybe<Scalars['JSON']>
  payload?: InputMaybe<Scalars['JSON']>
  type?: InputMaybe<CourtCasePaymentEventType>
  uuid?: InputMaybe<Scalars['ID']>
}

export enum CourtCasePaymentEventType {
  FirstInstance = 'FirstInstance',
  SecondInstance = 'SecondInstance',
  SelfInvolvement = 'SelfInvolvement',
  ThirdInstance = 'ThirdInstance'
}

export type CourtCasePaymentEventsCollection = {
  __typename?: 'CourtCasePaymentEventsCollection'
  first?: Maybe<CourtCasePaymentEvent>
  items: Array<CourtCasePaymentEvent>
  last?: Maybe<CourtCasePaymentEvent>
  skip?: Maybe<Scalars['Int']>
  take?: Maybe<Scalars['Int']>
  total: Scalars['Int']
}

export type CourtCasePaymentEventsListFilterInput = {
  courtCaseUuid?: InputMaybe<StringFilter>
  includeArchived?: InputMaybe<BooleanFilter>
  type?: InputMaybe<StringFilter>
}

export type CourtCasePaymentEventsListSortInput = {
  createdAt?: InputMaybe<SortDirection>
  updatedAt?: InputMaybe<SortDirection>
}

export enum CourtCaseState {
  Aborted = 'Aborted',
  Approved = 'Approved',
  ClientFileApproved = 'ClientFileApproved',
  ClientFileCreated = 'ClientFileCreated',
  ClientFileOpenedByLawyer = 'ClientFileOpenedByLawyer',
  ClientFileRejected = 'ClientFileRejected',
  ClientFileUpdated = 'ClientFileUpdated',
  CoveragePending = 'CoveragePending',
  Open = 'Open',
  Rejected = 'Rejected',
  ServiceRequested = 'ServiceRequested',
  Settled = 'Settled',
  UpdatedByCustomer = 'UpdatedByCustomer',
  UpdatedByLawyer = 'UpdatedByLawyer'
}

export type CourtCaseStateFilter = {
  equals?: InputMaybe<CourtCaseState>
  in?: InputMaybe<Array<CourtCaseState>>
  not_equals?: InputMaybe<CourtCaseState>
  not_in?: InputMaybe<Array<CourtCaseState>>
}

export type CourtCasesCollection = {
  __typename?: 'CourtCasesCollection'
  first?: Maybe<CourtCase>
  items: Array<CourtCase>
  last?: Maybe<CourtCase>
  skip?: Maybe<Scalars['Int']>
  take?: Maybe<Scalars['Int']>
  total: Scalars['Int']
}

export type CourtCasesListFilterInput = {
  archived?: InputMaybe<BooleanFilter>
  assignedAgentId?: InputMaybe<IntFilter>
  assignedAt?: InputMaybe<DateFilter>
  assignedLawyerId?: InputMaybe<IntFilter>
  coveredByICService?: InputMaybe<BooleanFilter>
  createdAt?: InputMaybe<DateFilter>
  customerId?: InputMaybe<IntFilter>
  includeUpcomingAppointment?: InputMaybe<BooleanFilter>
  includeUpcomingDeadline?: InputMaybe<BooleanFilter>
  insuranceClaimUuid?: InputMaybe<StringFilter>
  insuranceCoverageState?: InputMaybe<CourtCaseCoverageStateFilter>
  isAssigned?: InputMaybe<BooleanFilter>
  isCovered?: InputMaybe<BooleanFilter>
  membershipTypeUid?: InputMaybe<StringFilter>
  ongoing?: InputMaybe<BooleanFilter>
  referenceNumber?: InputMaybe<StringFilter>
  state?: InputMaybe<CourtCaseStateFilter>
  topicId?: InputMaybe<IntFilter>
  updatedAt?: InputMaybe<DateFilter>
  uuid?: InputMaybe<StringFilter>
}

export type CourtCasesListSortInput = {
  adminDeadline?: InputMaybe<SortDirection>
  appointmentAt?: InputMaybe<SortDirection>
  createdAt?: InputMaybe<SortDirection>
  lastTransitionAt?: InputMaybe<SortDirection>
  latestQuestionApprovedAt?: InputMaybe<SortDirection>
  upcomingAppointment?: InputMaybe<SortDirection>
  upcomingDeadline?: InputMaybe<SortDirection>
  updatedAt?: InputMaybe<SortDirection>
}

export enum CoverageVerificationResult {
  UnVerified = 'UnVerified',
  UnknownClient = 'UnknownClient',
  Verified = 'Verified'
}

export type CreateAdminInput = {
  email: Scalars['String']
  firstName: Scalars['String']
  lastName: Scalars['String']
  password: Scalars['String']
}

export type CreateConflictOfInterestInput = {
  adminId: Scalars['Int']
  customerId: Scalars['Int']
}

export type CreateConflictOfInterestResult = {
  __typename?: 'CreateConflictOfInterestResult'
  alreadyActive?: Maybe<Scalars['Boolean']>
  conflictOfInterest: ConflictOfInterest
}

export type CreateCustomerInput = {
  address: Address
  email: Scalars['String']
  firstName: Scalars['String']
  gender?: InputMaybe<Scalars['String']>
  lastName: Scalars['String']
  phone?: InputMaybe<Scalars['String']>
}

export type CreateInsuranceClaimInput = {
  agentReferral: Scalars['Boolean']
  customerId: Scalars['Int']
  expiresAt?: InputMaybe<Scalars['DateTime']>
  insurancePartner: InsuranceClaimPartner
  insuredEventDate?: InputMaybe<Scalars['DateTime']>
  insuredEventDescription?: InputMaybe<Scalars['String']>
  insuredPropertyAddress?: InputMaybe<Scalars['String']>
  insuredPropertyAffiliation?: InputMaybe<InsuredPropertyAffiliation>
  insuredPropertyType?: InputMaybe<InsuredPropertyType>
  notes?: InputMaybe<Scalars['String']>
  referenceNumber?: InputMaybe<Scalars['String']>
  serviceEvent: Scalars['String']
  topicIds: Array<Scalars['Int']>
}

export type CreateLawyerHolidayInput = {
  endDate: Scalars['DateTime']
  isCompletelyUnavailable: Scalars['Boolean']
  lawyerId: Scalars['Int']
  reason: LawyerHolidayReason
  startDate: Scalars['DateTime']
}

export type CreateServiceTaskInput = {
  checked?: InputMaybe<Scalars['Boolean']>
  customerId: Scalars['Int']
  description?: InputMaybe<Scalars['String']>
  dueDate: Scalars['DateTime']
  firstEmailSent?: InputMaybe<Scalars['DateTime']>
  title: Scalars['String']
  type?: InputMaybe<Scalars['String']>
}

export type CreateTemplatePdfResult = {
  __typename?: 'CreateTemplatePdfResult'
  fileUrl: Scalars['String']
}

export type Customer = {
  __typename?: 'Customer'
  address?: Maybe<OptionalAddress>
  blockingInvoices: Array<StripeBlockingInvoice>
  cases?: Maybe<Array<Case>>
  chat: MessagesCollection
  /** @deprecated Use case status instead */
  conversationStatus: ConversationStatus
  createdAt?: Maybe<Scalars['DateTime']>
  currentSingleProductPurchase?: Maybe<Purchase>
  customerServiceComment?: Maybe<CustomerServiceComment>
  dateOfBirth?: Maybe<Scalars['DateTime']>
  documents: Array<CustomerDocument>
  email: Scalars['String']
  firstName?: Maybe<Scalars['String']>
  gender?: Maybe<Gender>
  hasPayment: Scalars['Boolean']
  hubspotDeals: Array<HubspotDeal>
  hubspotVid?: Maybe<Scalars['String']>
  id: Scalars['Int']
  isEmailConfirmed?: Maybe<Scalars['Boolean']>
  isSpringerCustomer: Scalars['Boolean']
  lastName?: Maybe<Scalars['String']>
  latestAnswer?: Maybe<Message>
  latestCase?: Maybe<Case>
  latestMessage?: Maybe<Message>
  latestPurchase?: Maybe<Purchase>
  latestQuestion?: Maybe<Message>
  lawyer?: Maybe<Lawyer>
  leadType?: Maybe<LeadType>
  letterAllowance?: Maybe<LetterAllowance>
  membership?: Maybe<Membership>
  membershipHistory: Array<Membership>
  messages: Array<Message>
  mobilePhone?: Maybe<Scalars['String']>
  note?: Maybe<CustomerNote>
  paymentMethods: Array<StripePaymentMethod>
  phone?: Maybe<Scalars['String']>
  profilePictureUrl?: Maybe<Scalars['String']>
  purchases: PurchasesCollection
  recommendedProducts?: Maybe<Array<Product>>
  singleProducts: Array<SingleProduct>
  subscriptions: Array<StripeSubscription>
  updatedAt?: Maybe<Scalars['DateTime']>
  validGermanMobileNumber?: Maybe<Scalars['String']>
}

export type CustomerChatArgs = {
  filters: MessagesListFilterInput
  pagination?: InputMaybe<PaginationInput>
  sorts?: InputMaybe<MessagesListSortInput>
}

export type CustomerPurchasesArgs = {
  filters: PurchasesListFilterInput
  pagination?: InputMaybe<PaginationInput>
  sorts?: InputMaybe<PurchasesListSortInput>
}

export type CustomerValidGermanMobileNumberArgs = {
  format?: InputMaybe<ValidGermanMobileNumberFormat>
}

export enum CustomerCategory {
  Active = 'Active',
  Ended = 'Ended',
  SingleProduct = 'SingleProduct'
}

export type CustomerCategoryFilter = {
  equals?: InputMaybe<CustomerCategory>
}

export type CustomerDocument = Document & {
  __typename?: 'CustomerDocument'
  category?: Maybe<CustomerDocumentCategory>
  checked?: Maybe<Scalars['Boolean']>
  createdAt: Scalars['DateTime']
  customer?: Maybe<Customer>
  documentDate?: Maybe<Scalars['DateTime']>
  downloadFileUrl: Scalars['String']
  effective?: Maybe<Scalars['Boolean']>
  effectiveDeliveryTime?: Maybe<Scalars['Float']>
  fileFormat?: Maybe<Scalars['String']>
  fileUrl: Scalars['String']
  id: Scalars['Int']
  identifiedClauses?: Maybe<Array<IdentifiedClause>>
  metadata: MetaData
  name: Scalars['String']
  previewImageUrl?: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
  utilityBillAnalysis?: Maybe<UtilityBillAnalysisResult>
}

export type CustomerDocumentCategory = {
  __typename?: 'CustomerDocumentCategory'
  createdAt: Scalars['DateTime']
  id: Scalars['Int']
  name: Scalars['String']
  updatedAt: Scalars['DateTime']
}

export type CustomerExistsAsAdminInput = {
  email: Scalars['String']
}

export type CustomerFeedback = {
  __typename?: 'CustomerFeedback'
  createdAt: Scalars['DateTime']
  feedback?: Maybe<Scalars['String']>
  firstAttempt?: Maybe<Scalars['DateTime']>
  id: Scalars['Int']
  lawyerSatisfaction?: Maybe<Scalars['Float']>
  message: Message
  overallSatisfaction?: Maybe<Scalars['Float']>
  reachedAt?: Maybe<Scalars['DateTime']>
  secondAttempt?: Maybe<Scalars['DateTime']>
  serviceNote?: Maybe<Scalars['String']>
  serviceSatisfaction?: Maybe<Scalars['Float']>
  updatedAt: Scalars['DateTime']
}

export type CustomerFeedbackList = {
  __typename?: 'CustomerFeedbackList'
  badFeedbacks: Array<RecentCustomerFeedback>
  goodFeedbacks: Array<RecentCustomerFeedback>
  secondAttempts: Array<RecentCustomerFeedback>
}

export type CustomerForInteraction = {
  __typename?: 'CustomerForInteraction'
  firstName: Scalars['String']
  id: Scalars['Float']
  lastName: Scalars['String']
}

export type CustomerMessageUpdate = {
  content?: InputMaybe<Scalars['String']>
  id: Scalars['Int']
  messageTypePreference?: InputMaybe<MessageTypePreference>
  sentAt?: InputMaybe<Scalars['DateTime']>
  topicId?: InputMaybe<Scalars['Int']>
  topicQuestionnaireAnswers?: InputMaybe<Scalars['JSON']>
}

export type CustomerNote = {
  __typename?: 'CustomerNote'
  createdAt: Scalars['DateTime']
  customer: Customer
  id: Scalars['Int']
  lawyer: Lawyer
  note: Scalars['String']
  updatedAt: Scalars['DateTime']
}

export type CustomerSatisfactionTelephoneSurvey = {
  __typename?: 'CustomerSatisfactionTelephoneSurvey'
  answerMessageId: Scalars['Int']
  comment?: Maybe<Scalars['String']>
  createdAt: Scalars['DateTime']
  customerSupportSatisfaction?: Maybe<Scalars['Int']>
  documentUploadExperience?: Maybe<DocumentUploadExperience>
  helpfulRecommendedAction?: Maybe<Scalars['Int']>
  lawyerTelephoneConsultationTime?: Maybe<LawyerTelephoneConsultationTime>
  pleasantPhoneCall?: Maybe<Scalars['Int']>
  questionMessageId: Scalars['Int']
  questionsClarified?: Maybe<Scalars['Int']>
  tenancyIssueStatus?: Maybe<TenancyIssueStatus>
  updatedAt: Scalars['DateTime']
  usedTemplatesOrChecklists?: Maybe<UsedTemplatesOrChecklists>
}

export type CustomerSatisfactionTelephoneSurveyInput = {
  answerMessageId: Scalars['Int']
  comment?: InputMaybe<Scalars['String']>
  customerSupportSatisfaction?: InputMaybe<Scalars['Int']>
  documentUploadExperience?: InputMaybe<DocumentUploadExperience>
  helpfulRecommendedAction?: InputMaybe<Scalars['Int']>
  lawyerTelephoneConsultationTime?: InputMaybe<LawyerTelephoneConsultationTime>
  pleasantPhoneCall?: InputMaybe<Scalars['Int']>
  questionMessageId: Scalars['Int']
  questionsClarified?: InputMaybe<Scalars['Int']>
  tenancyIssueStatus?: InputMaybe<TenancyIssueStatus>
  usedTemplatesOrChecklists?: InputMaybe<UsedTemplatesOrChecklists>
}

export type CustomerSatisfactionWrittenFormSurvey = {
  __typename?: 'CustomerSatisfactionWrittenFormSurvey'
  answerMessageId: Scalars['Int']
  comment?: Maybe<Scalars['String']>
  comprehensibleResponse?: Maybe<Scalars['Int']>
  createdAt: Scalars['DateTime']
  customerSupportSatisfaction?: Maybe<Scalars['Int']>
  detailedResponse?: Maybe<Scalars['Int']>
  documentUploadExperience?: Maybe<DocumentUploadExperience>
  helpfulRecommendedAction?: Maybe<Scalars['Int']>
  lawyerResponseTime?: Maybe<LawyerResponseTime>
  questionMessageId: Scalars['Int']
  tenancyIssueStatus?: Maybe<TenancyIssueStatus>
  updatedAt: Scalars['DateTime']
  usedTemplatesOrChecklists?: Maybe<UsedTemplatesOrChecklists>
}

export type CustomerSatisfactionWrittenFormSurveyInput = {
  answerMessageId: Scalars['Int']
  comment?: InputMaybe<Scalars['String']>
  comprehensibleResponse?: InputMaybe<Scalars['Int']>
  customerSupportSatisfaction?: InputMaybe<Scalars['Int']>
  detailedResponse?: InputMaybe<Scalars['Int']>
  documentUploadExperience?: InputMaybe<DocumentUploadExperience>
  helpfulRecommendedAction?: InputMaybe<Scalars['Int']>
  lawyerResponseTime?: InputMaybe<LawyerResponseTime>
  questionMessageId: Scalars['Int']
  tenancyIssueStatus?: InputMaybe<TenancyIssueStatus>
  usedTemplatesOrChecklists?: InputMaybe<UsedTemplatesOrChecklists>
}

export type CustomerServiceComment = {
  __typename?: 'CustomerServiceComment'
  comment: Scalars['String']
}

export enum CustomerType {
  AiChecks = 'aiChecks',
  DigitalServicesSignup = 'digitalServicesSignup',
  Tenant = 'tenant'
}

export type CustomersCollection = {
  __typename?: 'CustomersCollection'
  first?: Maybe<Customer>
  items: Array<Customer>
  last?: Maybe<Customer>
  skip?: Maybe<Scalars['Int']>
  take?: Maybe<Scalars['Int']>
  total: Scalars['Int']
}

export type CustomersListFilterInput = {
  consultationId?: InputMaybe<StringFilter>
  createdAt?: InputMaybe<DateFilter>
  customerCategory?: InputMaybe<CustomerCategoryFilter>
  email?: InputMaybe<StringFilter>
  id?: InputMaybe<IntFilter>
  keyword?: InputMaybe<KeywordFilter>
  lawyerId?: InputMaybe<IntFilter>
  memberSince?: InputMaybe<DateFilter>
  membershipNumber?: InputMaybe<StringFilter>
  nameSearch?: InputMaybe<KeywordFilter>
  phone?: InputMaybe<StringFilter>
  productName?: InputMaybe<StringFilter>
  referenceNumber?: InputMaybe<StringFilter>
  updatedAt?: InputMaybe<DateFilter>
}

export type CustomersListSortInput = {
  createdAt?: InputMaybe<SortDirection>
  id?: InputMaybe<SortDirection>
  lastName?: InputMaybe<SortDirection>
  memberSince?: InputMaybe<SortDirection>
  updatedAt?: InputMaybe<SortDirection>
}

export type DateFilter = {
  equals?: InputMaybe<Scalars['DateTime']>
  gt?: InputMaybe<Scalars['DateTime']>
  gte?: InputMaybe<Scalars['DateTime']>
  in?: InputMaybe<Array<Scalars['DateTime']>>
  lt?: InputMaybe<Scalars['DateTime']>
  lte?: InputMaybe<Scalars['DateTime']>
  not_equals?: InputMaybe<Scalars['DateTime']>
  not_in?: InputMaybe<Array<Scalars['DateTime']>>
}

export type DeadlinesCheck = {
  __typename?: 'DeadlinesCheck'
  conditions: Array<Condition>
  context: DeadlinesContext
  name: UtilityBillCheckName
  outcome: Outcome
}

export type DeadlinesContext = {
  __typename?: 'DeadlinesContext'
  values: DeadlinesContextValues
}

export type DeadlinesContextValues = {
  __typename?: 'DeadlinesContextValues'
  issueDate?: Maybe<Scalars['String']>
  servicePeriodEnd?: Maybe<Scalars['String']>
  servicePeriodStart?: Maybe<Scalars['String']>
}

export type DeleteInsuranceClaimInput = {
  uuid: Scalars['ID']
}

export type DeleteSupportRequestInput = {
  messageId: Scalars['Int']
}

export enum DeliveryMethod {
  Digital = 'Digital',
  Paper = 'Paper'
}

export type DetachInsuranceClaimFromCaseInput = {
  caseId: Scalars['Int']
  insuranceClaimUuid: Scalars['ID']
}

export enum Deviation {
  Inconclusive = 'Inconclusive',
  Major = 'Major',
  Minor = 'Minor',
  Negligible = 'Negligible'
}

export type Distribution = {
  __typename?: 'Distribution'
  isValid?: Maybe<Scalars['Boolean']>
  key?: Maybe<Scalars['String']>
}

export type DistributionFormulaCheck = {
  __typename?: 'DistributionFormulaCheck'
  children: Array<DistributionFormulaChildren>
  conditions: Array<Condition>
  name: UtilityBillCheckName
  outcome: Outcome
}

export type DistributionFormulaChildren = {
  __typename?: 'DistributionFormulaChildren'
  conditions: Array<Condition>
  context: DistributionFormulaContext
  name: Scalars['String']
  outcome: Outcome
}

export type DistributionFormulaContext = {
  __typename?: 'DistributionFormulaContext'
  category?: Maybe<Scalars['String']>
  distributionKey: Scalars['String']
  item: Scalars['String']
}

export type Document = {
  createdAt: Scalars['DateTime']
  documentDate?: Maybe<Scalars['DateTime']>
  downloadFileUrl: Scalars['String']
  effective?: Maybe<Scalars['Boolean']>
  fileFormat?: Maybe<Scalars['String']>
  fileUrl: Scalars['String']
  id: Scalars['Int']
  identifiedClauses?: Maybe<Array<IdentifiedClause>>
  name: Scalars['String']
  previewImageUrl?: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
}

export enum DocumentUploadExperience {
  InitialDifficulties = 'InitialDifficulties',
  SystemMalfunction = 'SystemMalfunction',
  VeryGood = 'VeryGood',
  WithoutUpload = 'WithoutUpload'
}

export type DowngradeMembershipInput = {
  productId: Scalars['Int']
}

export type EmailTemplate = {
  __typename?: 'EmailTemplate'
  categoryCustomer: Scalars['String']
  categoryLawyer?: Maybe<Scalars['String']>
  content: Scalars['String']
  createdAt: Scalars['DateTime']
  description: Scalars['String']
  id: Scalars['Float']
  link: Scalars['String']
  name: Scalars['String']
  subject: Scalars['String']
  updatedAt: Scalars['DateTime']
}

export type EmptyResponse = {
  __typename?: 'EmptyResponse'
  _?: Maybe<Scalars['Boolean']>
}

export type Feature = {
  __typename?: 'Feature'
  description: Scalars['String']
  globalFeature?: Maybe<GlobalFeature>
  id: Scalars['Int']
  name: Scalars['String']
  userGroupFeatures: Array<UserGroupFeature>
}

export type FeatureFlag = {
  __typename?: 'FeatureFlag'
  enabled: Scalars['Boolean']
  uid: Scalars['String']
}

export type FeedbackUpdate = {
  feedback?: InputMaybe<Scalars['String']>
  feedbackId: Scalars['Int']
  lawyerSatisfaction: Scalars['Int']
  messageId: Scalars['Int']
  serviceSatisfaction: Scalars['Int']
}

export type FormalRequirementsCheck = {
  __typename?: 'FormalRequirementsCheck'
  conditions: Array<Condition>
  name: UtilityBillCheckName
  outcome: Outcome
}

export enum Gender {
  D = 'D',
  F = 'F',
  M = 'M'
}

export type GenerateBookingLinkResult = {
  __typename?: 'GenerateBookingLinkResult'
  bookingLink: Scalars['String']
}

export type GenerateCustomerBookingLinkInput = {
  customer: AppointmentCustomer
  fromPage?: InputMaybe<Scalars['String']>
  iframe: Scalars['Boolean']
  lawyer: AppointmentLawyer
  messageId: Scalars['Int']
}

export type GenerateLeadBookingLinkInput = {
  customer: AppointmentLead
  fromPage?: InputMaybe<Scalars['String']>
  iframe: Scalars['Boolean']
  lawyer: AppointmentLawyer
  topicId: Scalars['Int']
}

export type GetEmailTemplateInput = {
  categoryCustomer?: InputMaybe<Scalars['String']>
  categoryLawyer?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['Float']>
  name?: InputMaybe<Scalars['String']>
}

export type GlobalFeature = {
  __typename?: 'GlobalFeature'
  enabled: Scalars['Boolean']
}

export type GlobalReportFilterKpi = {
  endDate: Scalars['DateTime']
  startDate: Scalars['DateTime']
}

export type GlobalReportKpi = {
  __typename?: 'GlobalReportKpi'
  totals: GlobalReportTotalsKpi
}

export type GlobalReportTotalsKpi = {
  __typename?: 'GlobalReportTotalsKpi'
  leads: Scalars['Int']
}

export type HubspotDeal = {
  __typename?: 'HubspotDeal'
  amount: Scalars['Float']
  closeDate: Scalars['DateTime']
  createdAt: Scalars['DateTime']
  dealName: Scalars['String']
  dealStage: Scalars['String']
  id: Scalars['Int']
  lawyerKey: Scalars['String']
  paymentMethod: Scalars['String']
  paymentStage: Scalars['String']
  pipeline: Scalars['String']
  productId: Scalars['Int']
}

export type IdentifiedClause = {
  __typename?: 'IdentifiedClause'
  effective: Scalars['Boolean']
  spans: Array<ClauseSpan>
  type: Scalars['String']
}

export type ImDocumentQueryParams = {
  categoryIds?: InputMaybe<Array<Scalars['Int']>>
  excludeId?: InputMaybe<Scalars['Float']>
  limit?: InputMaybe<Scalars['Float']>
  typeId?: InputMaybe<Scalars['Float']>
}

export type InformationMaterial = {
  __typename?: 'InformationMaterial'
  imCategories?: Maybe<Array<InformationMaterialCategory>>
  imDocument?: Maybe<InformationMaterialDocument>
  imDocuments?: Maybe<Array<InformationMaterialDocument>>
}

export type InformationMaterialImDocumentArgs = {
  documentId: Scalars['Int']
}

export type InformationMaterialImDocumentsArgs = {
  imDocumentQueryParams: ImDocumentQueryParams
}

export type InformationMaterialCategory = {
  __typename?: 'InformationMaterialCategory'
  id: Scalars['Int']
  name: Scalars['String']
}

export type InformationMaterialDocument = {
  __typename?: 'InformationMaterialDocument'
  categories?: Maybe<Array<InformationMaterialCategory>>
  description?: Maybe<Scalars['String']>
  documentType: InformationMaterialType
  fileFormat?: Maybe<Scalars['String']>
  fileUrl?: Maybe<Scalars['String']>
  hubspotProblemTopic?: Maybe<Scalars['String']>
  id: Scalars['Int']
  name?: Maybe<Scalars['String']>
  previewImageUrl?: Maybe<Scalars['String']>
  template?: Maybe<Template>
  templateUid?: Maybe<Scalars['String']>
}

export type InformationMaterialType = {
  __typename?: 'InformationMaterialType'
  id: Scalars['Int']
  name?: Maybe<Scalars['String']>
}

export type InitialFeedback = {
  messageId: Scalars['Int']
  overallSatisfaction: Scalars['Int']
}

export type InkassoCase = {
  __typename?: 'InkassoCase'
  createdAt: Scalars['DateTime']
  inkassoCaseId: Scalars['String']
  lastTransitionAt?: Maybe<Scalars['DateTime']>
  state: InkassoCaseState
  stripeCustomerInvoice?: Maybe<StripeCustomerInvoice>
  stripeCustomerInvoiceId: Scalars['String']
  updatedAt: Scalars['DateTime']
}

export enum InkassoCaseState {
  Open = 'Open',
  Paid = 'Paid',
  PaymentUnconfirmed = 'PaymentUnconfirmed',
  Uncollectable = 'Uncollectable'
}

export type InsuranceClaim = {
  __typename?: 'InsuranceClaim'
  cases: Array<Case>
  clearedAt?: Maybe<Scalars['DateTime']>
  createdAt: Scalars['DateTime']
  customer: Customer
  customerId: Scalars['Int']
  expiresAt?: Maybe<Scalars['DateTime']>
  initiatedAt?: Maybe<Scalars['DateTime']>
  insurancePartner: InsuranceClaimPartner
  insuredEventDate?: Maybe<Scalars['DateTime']>
  insuredEventDescription?: Maybe<Scalars['String']>
  insuredPropertyAddress?: Maybe<Scalars['String']>
  insuredPropertyAffiliation?: Maybe<InsuredPropertyAffiliation>
  insuredPropertyType?: Maybe<InsuredPropertyType>
  invoicedAt?: Maybe<Scalars['DateTime']>
  lastTransitionAt: Scalars['DateTime']
  notes?: Maybe<Scalars['String']>
  previousTopics: Array<Topic>
  purchase?: Maybe<Purchase>
  purchaseId: Scalars['Int']
  referenceNumber?: Maybe<Scalars['String']>
  requestedAt?: Maybe<Scalars['DateTime']>
  services: Array<InsuranceClaimService>
  state: InsuranceClaimState
  topics: Array<Topic>
  updatedAt: Scalars['DateTime']
  uuid: Scalars['ID']
}

export enum InsuranceClaimPartner {
  Adac = 'adac',
  Advocard = 'advocard',
  Allianz = 'allianz',
  Arag = 'arag',
  Auxilia = 'auxilia',
  Badische = 'badische',
  Concordia = 'concordia',
  Continentale = 'continentale',
  Debeka = 'debeka',
  Deurag = 'deurag',
  Devk = 'devk',
  Dmb = 'dmb',
  Ergo = 'ergo',
  HukCoburg = 'huk_coburg',
  Immoscout24 = 'immoscout24',
  Itzehoer = 'itzehoer',
  Klugo = 'klugo',
  Lvm = 'lvm',
  Mecklenburgische = 'mecklenburgische',
  NeueRechtsschutz = 'neue_rechtsschutz',
  Oerag = 'oerag',
  RPlusV = 'r_plus_v',
  Roland = 'roland',
  Vgh = 'vgh',
  Wgv = 'wgv',
  Wuerttembergische = 'wuerttembergische'
}

export type InsuranceClaimPartnerFilter = {
  equals?: InputMaybe<InsuranceClaimPartner>
  in?: InputMaybe<Array<InsuranceClaimPartner>>
  not_equals?: InputMaybe<InsuranceClaimPartner>
  not_in?: InputMaybe<Array<InsuranceClaimPartner>>
}

export type InsuranceClaimPayload = {
  insuranceClaimProps?: InputMaybe<InsuranceClaimProps>
  serviceEvent?: InputMaybe<Scalars['String']>
}

export type InsuranceClaimProps = {
  insuredPropertyAffiliation?: InputMaybe<Scalars['String']>
  insuredPropertyType?: InputMaybe<Scalars['String']>
  referenceNumber?: InputMaybe<Scalars['String']>
}

export type InsuranceClaimService = {
  __typename?: 'InsuranceClaimService'
  cases: Array<Case>
  consultationId?: Maybe<Scalars['String']>
  courtCase?: Maybe<CourtCase>
  coverageConfirmationSource?: Maybe<Scalars['String']>
  coverageConfirmed: Scalars['Boolean']
  coverageConfirmedOn?: Maybe<Scalars['DateTime']>
  createdAt: Scalars['DateTime']
  customerId: Scalars['Int']
  insuranceClaimUuid: Scalars['String']
  metadata?: Maybe<Scalars['JSONObject']>
  serviceUid: Scalars['String']
  updatedAt: Scalars['DateTime']
  used: Scalars['Boolean']
  usedOnDate?: Maybe<Scalars['DateTime']>
  uuid: Scalars['ID']
}

export type InsuranceClaimServicesCollection = {
  __typename?: 'InsuranceClaimServicesCollection'
  first?: Maybe<InsuranceClaimService>
  items: Array<InsuranceClaimService>
  last?: Maybe<InsuranceClaimService>
  skip?: Maybe<Scalars['Int']>
  take?: Maybe<Scalars['Int']>
  total: Scalars['Int']
}

export type InsuranceClaimServicesListFilterInput = {
  customerId?: InputMaybe<IntFilter>
  serviceUid?: InputMaybe<StringFilter>
  used?: InputMaybe<BooleanFilter>
  uuid?: InputMaybe<StringFilter>
}

export type InsuranceClaimServicesListSortInput = {
  createdAt?: InputMaybe<SortDirection>
  updatedAt?: InputMaybe<SortDirection>
  usedOnDate?: InputMaybe<SortDirection>
}

export enum InsuranceClaimState {
  Approved = 'Approved',
  Initiated = 'Initiated',
  Invoiced = 'Invoiced',
  PreApproved = 'PreApproved',
  Rejected = 'Rejected',
  Requested = 'Requested'
}

export type InsuranceClaimStateFilter = {
  equals?: InputMaybe<InsuranceClaimState>
  in?: InputMaybe<Array<InsuranceClaimState>>
  not_equals?: InputMaybe<InsuranceClaimState>
  not_in?: InputMaybe<Array<InsuranceClaimState>>
}

export type InsuranceClaimsCollection = {
  __typename?: 'InsuranceClaimsCollection'
  first?: Maybe<InsuranceClaim>
  items: Array<InsuranceClaim>
  last?: Maybe<InsuranceClaim>
  skip?: Maybe<Scalars['Int']>
  take?: Maybe<Scalars['Int']>
  total: Scalars['Int']
}

export type InsuranceClaimsListFilterInput = {
  createdAt?: InputMaybe<DateFilter>
  customerId?: InputMaybe<IntFilter>
  insuranceNumber?: InputMaybe<StringFilter>
  insurancePartner?: InputMaybe<InsuranceClaimPartnerFilter>
  lastTransitionAt?: InputMaybe<DateFilter>
  purchaseId?: InputMaybe<IntFilter>
  referenceNumber?: InputMaybe<StringFilter>
  reportDate?: InputMaybe<DateFilter>
  state?: InputMaybe<InsuranceClaimStateFilter>
  topicIds?: InputMaybe<IntFilter>
  updatedAt?: InputMaybe<DateFilter>
  uuid?: InputMaybe<StringFilter>
}

export type InsuranceClaimsListSortInput = {
  createdAt?: InputMaybe<SortDirection>
  lastTransitionAt?: InputMaybe<SortDirection>
  updatedAt?: InputMaybe<SortDirection>
}

export enum InsuredPropertyAffiliation {
  Landlord = 'landlord',
  Owner = 'owner',
  Tenant = 'tenant'
}

export enum InsuredPropertyType {
  Commercial = 'commercial',
  Garage = 'garage',
  Residential = 'residential'
}

export type IntFilter = {
  equals?: InputMaybe<Scalars['Int']>
  gt?: InputMaybe<Scalars['Int']>
  gte?: InputMaybe<Scalars['Int']>
  in?: InputMaybe<Array<Scalars['Int']>>
  lt?: InputMaybe<Scalars['Int']>
  lte?: InputMaybe<Scalars['Int']>
  not_equals?: InputMaybe<Scalars['Int']>
  not_in?: InputMaybe<Array<Scalars['Int']>>
}

export type InternalServiceNote = {
  __typename?: 'InternalServiceNote'
  admin: Admin
  createdAt: Scalars['DateTime']
  id: Scalars['Int']
  note: Scalars['String']
  updatedAt: Scalars['DateTime']
}

export type InvoiceItemCheck = {
  __typename?: 'InvoiceItemCheck'
  conditions: Array<Condition>
  context: InvoiceItemContext
  name: Scalars['String']
  outcome: Scalars['String']
}

export type InvoiceItemContext = {
  __typename?: 'InvoiceItemContext'
  amount?: Maybe<Scalars['Float']>
  category?: Maybe<Scalars['String']>
  deviation?: Maybe<Deviation>
  distribution?: Maybe<Distribution>
  increaseInPercent?: Maybe<Scalars['Float']>
  item: Scalars['String']
  prediction?: Maybe<Prediction>
  pricePerSqm?: Maybe<Scalars['Float']>
  pricePerSqmBenchmark?: Maybe<Scalars['Float']>
}

export type InvoiceItemsCheck = {
  __typename?: 'InvoiceItemsCheck'
  children: Array<InvoiceItemCheck>
  conditions: Array<Condition>
  name: UtilityBillCheckName
  outcome: Outcome
}

export type KeywordFilter = {
  equals?: InputMaybe<Scalars['String']>
}

export type Lawyer = {
  __typename?: 'Lawyer'
  address: RequiredAddress
  /** @deprecated column contains non uniform data in production. avoid using further */
  company: Scalars['String']
  courtCaseProgram?: Maybe<Scalars['Boolean']>
  createdAt: Scalars['DateTime']
  description?: Maybe<Scalars['String']>
  firstName: Scalars['String']
  gender: Gender
  hasPaypalEnabled?: Maybe<Scalars['Boolean']>
  hasTelesalesEnabled?: Maybe<Scalars['Boolean']>
  id: Scalars['Int']
  isMieterEngelLawyer?: Maybe<Scalars['Boolean']>
  lastName: Scalars['String']
  powerOfAttorneyAgent: Scalars['String']
  profilePictureUrl: Scalars['String']
  qlikAppId?: Maybe<Scalars['String']>
  qlikSheetId?: Maybe<Scalars['String']>
  title?: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
}

export enum LawyerAllocationGroup {
  Advocard = 'Advocard',
  AdvocardAiChecks = 'AdvocardAIChecks',
  Allianz = 'Allianz',
  Ergo = 'Ergo',
  ImmoScout24 = 'ImmoScout24',
  Itzehoer = 'Itzehoer',
  Klugo = 'Klugo',
  Lvm = 'Lvm',
  RenovationCheck = 'RenovationCheck',
  RentalContractCheck = 'RentalContractCheck',
  UtilityBillCheck = 'UtilityBillCheck'
}

export type LawyerAllocationGroupInput = {
  lawyerAllocationGroup: LawyerAllocationGroup
}

export type LawyerAllocationProbability = {
  __typename?: 'LawyerAllocationProbability'
  lawyer: SubscriptionAllocationLawyerData
  lawyerAllocationGroup: LawyerAllocationGroup
  percentage: Scalars['Float']
}

export type LawyerCustomerInteraction = {
  __typename?: 'LawyerCustomerInteraction'
  customer: CustomerForInteraction
  id: Scalars['Float']
  latestAppointmentDate?: Maybe<Scalars['DateTime']>
  topicName: Scalars['String']
  updatedAt: Scalars['DateTime']
}

export type LawyerDocument = Document & {
  __typename?: 'LawyerDocument'
  created?: Maybe<Scalars['DateTime']>
  createdAt: Scalars['DateTime']
  documentDate?: Maybe<Scalars['DateTime']>
  downloadFileUrl: Scalars['String']
  effective?: Maybe<Scalars['Boolean']>
  fileFormat?: Maybe<Scalars['String']>
  fileUrl: Scalars['String']
  id: Scalars['Int']
  identifiedClauses?: Maybe<Array<IdentifiedClause>>
  lawyer?: Maybe<Lawyer>
  name: Scalars['String']
  previewImageUrl?: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
}

export type LawyerHoliday = {
  __typename?: 'LawyerHoliday'
  createdAt: Scalars['DateTime']
  endDate: Scalars['DateTime']
  id: Scalars['Int']
  isCompletelyUnavailable: Scalars['Boolean']
  lawyer: Lawyer
  lawyerId: Scalars['Int']
  reason: LawyerHolidayReason
  startDate: Scalars['DateTime']
  updatedAt: Scalars['DateTime']
}

export enum LawyerHolidayReason {
  Miscellaneous = 'Miscellaneous',
  ParentalLeave = 'ParentalLeave',
  SickLeave = 'SickLeave',
  Vacation = 'Vacation'
}

export type LawyerHolidaysCollection = {
  __typename?: 'LawyerHolidaysCollection'
  first?: Maybe<LawyerHoliday>
  items: Array<LawyerHoliday>
  last?: Maybe<LawyerHoliday>
  skip?: Maybe<Scalars['Int']>
  take?: Maybe<Scalars['Int']>
  total: Scalars['Int']
}

export type LawyerHolidaysListFilterInput = {
  endDate?: InputMaybe<DateFilter>
  id?: InputMaybe<IntFilter>
  lawyerId?: InputMaybe<IntFilter>
  startDate?: InputMaybe<DateFilter>
}

export type LawyerHolidaysListSortInput = {
  fullName?: InputMaybe<SortDirection>
}

export type LawyerOption = {
  __typename?: 'LawyerOption'
  adviceHiringProblems?: Maybe<Scalars['Boolean']>
  lawyerLetters?: Maybe<Scalars['Boolean']>
  lawyerReplyTime?: Maybe<Scalars['Boolean']>
  throughoutGermany?: Maybe<Scalars['Boolean']>
}

export type LawyerProbabilityInput = {
  lawyerId: Scalars['Float']
  percentage: Scalars['Float']
}

export type LawyerReportEntryKpi = {
  __typename?: 'LawyerReportEntryKpi'
  auditReports: Scalars['Int']
  consultations: Scalars['Int']
  lawyerId: Scalars['Int']
  lettersSent: Scalars['Int']
  phoneAppointments: Scalars['Int']
}

export type LawyerReportFilterKpi = {
  endDate: Scalars['DateTime']
  lawyerIds: Array<Scalars['Int']>
  startDate: Scalars['DateTime']
}

export type LawyerReportKpi = {
  __typename?: 'LawyerReportKpi'
  entries: Array<LawyerReportEntryKpi>
  totals: LawyerReportTotalsKpi
}

export type LawyerReportTotalsKpi = {
  __typename?: 'LawyerReportTotalsKpi'
  auditReports: Scalars['Int']
  consultations: Scalars['Int']
  lettersSent: Scalars['Int']
  phoneAppointments: Scalars['Int']
}

export enum LawyerResponseTime {
  Fast = 'Fast',
  Neutral = 'Neutral',
  Slow = 'Slow'
}

export enum LawyerTelephoneConsultationTime {
  Fast = 'Fast',
  Neutral = 'Neutral',
  Slow = 'Slow'
}

export type LawyersCollection = {
  __typename?: 'LawyersCollection'
  first?: Maybe<Lawyer>
  items: Array<Lawyer>
  last?: Maybe<Lawyer>
  skip?: Maybe<Scalars['Int']>
  take?: Maybe<Scalars['Int']>
  total: Scalars['Int']
}

export type LawyersListFilterInput = {
  availableForChange?: InputMaybe<BooleanFilter>
  createdAt?: InputMaybe<DateFilter>
  id?: InputMaybe<IntFilter>
  includeFakeLawyers?: InputMaybe<BooleanFilter>
  isCourtCaseProgramLawyer?: InputMaybe<BooleanFilter>
  isEmailConfirmed?: InputMaybe<BooleanFilter>
  lastName?: InputMaybe<StringFilter>
  partnerName?: InputMaybe<PartnerUidFilter>
  updatedAt?: InputMaybe<DateFilter>
}

export type LawyersListSortInput = {
  createdAt?: InputMaybe<SortDirection>
  firstName?: InputMaybe<SortDirection>
  updatedAt?: InputMaybe<SortDirection>
}

export type Lead = {
  __typename?: 'Lead'
  acquisition: Scalars['JSONObject']
  assignedAgent: Admin
  assignedAgentId?: Maybe<Scalars['Int']>
  createdAt: Scalars['DateTime']
  customer: Customer
  customerId: Scalars['Int']
  lastSalesActionCreatedAt: Scalars['DateTime']
  lastTransitionAt: Scalars['DateTime']
  missedCalls: Scalars['Int']
  nextCallScheduledAt?: Maybe<Scalars['DateTime']>
  questionnaire: Scalars['JSONObject']
  salesActions: Array<LeadSalesAction>
  state: LeadState
  tasks: Array<LeadTask>
  updatedAt: Scalars['DateTime']
  uuid: Scalars['ID']
}

export type LeadSalesAction = {
  __typename?: 'LeadSalesAction'
  admin: Admin
  createdAt: Scalars['DateTime']
  lead: Lead
  medium: LeadSalesActionMedium
  responded: Scalars['Boolean']
  updatedAt: Scalars['DateTime']
  uuid: Scalars['ID']
}

export enum LeadSalesActionMedium {
  Phone = 'Phone'
}

export enum LeadState {
  Archived = 'Archived',
  Converted = 'Converted',
  FollowUpScheduled = 'FollowUpScheduled',
  Hit = 'Hit',
  Hot = 'Hot',
  LastChance = 'LastChance',
  Missed = 'Missed'
}

export type LeadStateFilter = {
  equals?: InputMaybe<LeadState>
  in?: InputMaybe<Array<LeadState>>
  not_equals?: InputMaybe<LeadState>
  not_in?: InputMaybe<Array<LeadState>>
}

export type LeadTask = {
  __typename?: 'LeadTask'
  admin: Admin
  createdAt: Scalars['DateTime']
  dueAt: Scalars['DateTime']
  isCompleted: Scalars['Boolean']
  lead: Lead
  note?: Maybe<Scalars['String']>
  task: Scalars['String']
  updatedAt: Scalars['DateTime']
  uuid: Scalars['ID']
}

export type LeadTasksCollection = {
  __typename?: 'LeadTasksCollection'
  first?: Maybe<LeadTask>
  items: Array<LeadTask>
  last?: Maybe<LeadTask>
  skip?: Maybe<Scalars['Int']>
  take?: Maybe<Scalars['Int']>
  total: Scalars['Int']
}

export type LeadTasksListFilterInput = {
  dueAt?: InputMaybe<DateFilter>
  state?: InputMaybe<LeadStateFilter>
}

export type LeadTasksListSortInput = {
  dueAt?: InputMaybe<SortDirection>
}

export enum LeadType {
  Freemium = 'Freemium',
  Funnel = 'Funnel',
  SeoDownload = 'SeoDownload',
  SignupFlow = 'SignupFlow',
  UtilityBill = 'UtilityBill'
}

export type LeadsCollection = {
  __typename?: 'LeadsCollection'
  first?: Maybe<Lead>
  items: Array<Lead>
  last?: Maybe<Lead>
  skip?: Maybe<Scalars['Int']>
  take?: Maybe<Scalars['Int']>
  total: Scalars['Int']
}

export type LeadsListFilterInput = {
  assignedAgentId?: InputMaybe<IntFilter>
  canBeCalled?: InputMaybe<BooleanFilter>
  createdAt?: InputMaybe<DateFilter>
  lastTransitionAt?: InputMaybe<DateFilter>
  nextCallScheduledAt?: InputMaybe<DateFilter>
  salesActionResponded?: InputMaybe<BooleanFilter>
  state?: InputMaybe<LeadStateFilter>
  updatedAt?: InputMaybe<DateFilter>
  uuid?: InputMaybe<StringFilter>
  verifiedEmailOnly?: InputMaybe<BooleanFilter>
}

export type LeadsListSortInput = {
  createdAt?: InputMaybe<SortDirection>
  lastSalesActionAt?: InputMaybe<SortDirection>
  lastTransitionAt?: InputMaybe<SortDirection>
  nextCallScheduledAt?: InputMaybe<SortDirection>
  updatedAt?: InputMaybe<SortDirection>
}

export type LetterAllowance = {
  __typename?: 'LetterAllowance'
  canRequestLetter: Scalars['Boolean']
  displayValue: Scalars['String']
}

export type LetterRequest = {
  __typename?: 'LetterRequest'
  canceledOn?: Maybe<Scalars['DateTime']>
  createdAt: Scalars['DateTime']
  customer: Customer
  id: Scalars['Int']
  lawyer?: Maybe<Lawyer>
  lawyerLetter?: Maybe<LawyerDocument>
  /** @deprecated Do not use */
  letterRequestId: Scalars['Int']
  postponedOn?: Maybe<Scalars['DateTime']>
  powerOfAttorney?: Maybe<PowerOfAttorney>
  question: Message
  /** @deprecated Do not use */
  questionId: Scalars['Int']
  updatedAt: Scalars['DateTime']
}

export type LetterRequestForCustomer = {
  __typename?: 'LetterRequestForCustomer'
  letterAllowance?: Maybe<LetterAllowance>
  /** @deprecated use messages.letterRequest resolver */
  letterDocumentIds: Array<Scalars['Int']>
  /** @deprecated use messages.letterRequest resolver */
  openLetterRequest?: Maybe<LetterRequest>
  /** @deprecated use messages.letterRequest resolver */
  questionsWithRequests: Array<Scalars['Int']>
  upgradeProduct?: Maybe<Product>
}

export type MarkInkassoCaseAsUnconfirmedInput = {
  stripeCustomerInvoiceId: Scalars['String']
}

export type MarkInsuranceClaimAsApprovedInput = {
  referenceNumber?: InputMaybe<Scalars['String']>
  uuid: Scalars['ID']
}

export type MarkInsuranceClaimAsInvoicedInput = {
  referenceNumber: Scalars['String']
  uuid: Scalars['ID']
}

export type MarkInsuranceClaimAsRejectedInput = {
  referenceNumber?: InputMaybe<Scalars['String']>
  uuid: Scalars['ID']
}

export type MarkInsuranceClaimAsRequestedInput = {
  uuid: Scalars['ID']
}

export type MarkInsuranceClaimsAsInvoicedInput = {
  insuranceClaims: Array<MarkInsuranceClaimAsInvoicedInput>
}

export type MarkMessageAsCheckedInput = {
  messageId: Scalars['Int']
}

export type Membership = {
  __typename?: 'Membership'
  activatedAt: Scalars['DateTime']
  advancedFrom?: Maybe<Membership>
  advancedFromUuid?: Maybe<Scalars['String']>
  advancement: Array<Membership>
  cancellationPolicy: MembershipCancellationPolicy
  cancellationReason?: Maybe<Scalars['String']>
  cancellationRequestedAt?: Maybe<Scalars['DateTime']>
  changePolicy: MembershipChangePolicy
  createdAt: Scalars['DateTime']
  customer: Customer
  customerId: Scalars['Int']
  earliestEndDate: Scalars['DateTime']
  endsAt?: Maybe<Scalars['DateTime']>
  hasAllianzProtection: Scalars['Boolean']
  isReferredByPartner: Scalars['Boolean']
  lawyer: Lawyer
  lawyerId: Scalars['Int']
  membershipNumber: Scalars['String']
  membershipType: MembershipType
  membershipTypeUid: Scalars['String']
  notes?: Maybe<Scalars['String']>
  product: Product
  productId: Scalars['Int']
  purchase: Purchase
  purchaseId: Scalars['Int']
  services: Array<Service>
  startsAt: Scalars['DateTime']
  state: MembershipState
  terminationCode?: Maybe<MembershipTerminationCode>
  terminationGround?: Maybe<Scalars['String']>
  updatedAt: Scalars['DateTime']
  uuid: Scalars['ID']
}

export type MembershipCancellationPolicy = {
  __typename?: 'MembershipCancellationPolicy'
  earliestContractualTerminationDate: Scalars['DateTime']
  isCancellationAllowed: Scalars['Boolean']
  isCancellationRevocationAllowed: Scalars['Boolean']
}

export type MembershipChangePolicy = {
  __typename?: 'MembershipChangePolicy'
  isChangeLawyerAllowed: Scalars['Boolean']
}

export enum MembershipState {
  Aborted = 'Aborted',
  Active = 'Active',
  Ended = 'Ended',
  Paused = 'Paused',
  Scheduled = 'Scheduled'
}

export enum MembershipTerminationCode {
  Advanced = 'Advanced',
  Cancelled = 'Cancelled',
  Revoked = 'Revoked',
  TypeSwitched = 'TypeSwitched'
}

export type MembershipType = {
  __typename?: 'MembershipType'
  createdAt: Scalars['DateTime']
  displayName: Scalars['String']
  level: Scalars['String']
  partner?: Maybe<Scalars['String']>
  partnerFullPartnership?: Maybe<Scalars['Boolean']>
  uid: Scalars['String']
  updatedAt: Scalars['DateTime']
}

export type Message = {
  __typename?: 'Message'
  answerIsOverdueEmailSent?: Maybe<Scalars['Boolean']>
  appointmentAt?: Maybe<Scalars['DateTime']>
  /** @deprecated Do not use. Instead use appointmentAt to check if appointment is present or manipulate the appointment through the message controllers */
  appointmentId?: Maybe<Scalars['Float']>
  approvedAt?: Maybe<Scalars['DateTime']>
  auditReport?: Maybe<AuditReport>
  bookingChangeLink?: Maybe<Scalars['String']>
  bookingProvider?: Maybe<BookingProvider>
  bookingReference?: Maybe<Scalars['String']>
  case?: Maybe<Case>
  checkedAt?: Maybe<Scalars['DateTime']>
  content?: Maybe<Scalars['String']>
  courtCase?: Maybe<CourtCase>
  createdAt: Scalars['DateTime']
  customer: Customer
  documents?: Maybe<Array<Document>>
  id: Scalars['Int']
  lawyer?: Maybe<Lawyer>
  lawyerSubstitution: Scalars['Boolean']
  letterRequest?: Maybe<LetterRequest>
  messageHasTemplate?: Maybe<MessageHasTemplate>
  messageTypePreference?: Maybe<MessageTypePreference>
  rejectedAt?: Maybe<Scalars['DateTime']>
  rejectionReason?: Maybe<Scalars['String']>
  sentAt?: Maybe<Scalars['DateTime']>
  serviceComment?: Maybe<ServiceComment>
  serviceNotes?: Maybe<Array<InternalServiceNote>>
  topic: Topic
  topicQuestionnaireAnswers?: Maybe<Scalars['JSON']>
  type: MessageType
  updatedAt: Scalars['DateTime']
}

export type MessageHasTemplate = {
  __typename?: 'MessageHasTemplate'
  createdAt: Scalars['DateTime']
  emailTemplate: EmailTemplate
  message: Message
  updatedAt: Scalars['DateTime']
}

export enum MessageType {
  Answer = 'Answer',
  CourtCaseCustomer = 'CourtCaseCustomer',
  CourtCaseLawyer = 'CourtCaseLawyer',
  Information = 'Information',
  Question = 'Question'
}

export type MessageTypeFilter = {
  equals?: InputMaybe<MessageType>
  in?: InputMaybe<Array<MessageType>>
  not_equals?: InputMaybe<MessageType>
  not_in?: InputMaybe<Array<MessageType>>
}

export enum MessageTypePreference {
  InWriting = 'InWriting',
  ViaPhone = 'ViaPhone'
}

export type MessageTypePreferenceFilter = {
  equals?: InputMaybe<MessageTypePreference>
  in?: InputMaybe<Array<MessageTypePreference>>
  not_equals?: InputMaybe<MessageTypePreference>
  not_in?: InputMaybe<Array<MessageTypePreference>>
}

export type MessagesCollection = {
  __typename?: 'MessagesCollection'
  first?: Maybe<Message>
  items: Array<Message>
  last?: Maybe<Message>
  skip?: Maybe<Scalars['Int']>
  take?: Maybe<Scalars['Int']>
  total: Scalars['Int']
}

export type MessagesListFilterInput = {
  caseId?: InputMaybe<IntFilter>
  courtCaseUuid?: InputMaybe<StringFilter>
  customerId?: InputMaybe<IntFilter>
  id?: InputMaybe<IntFilter>
  lawyerId?: InputMaybe<IntFilter>
  messageType?: InputMaybe<MessageTypeFilter>
  topicId?: InputMaybe<IntFilter>
}

export type MessagesListSortInput = {
  createdAt?: InputMaybe<SortDirection>
  updatedAt?: InputMaybe<SortDirection>
}

export type MetaData = {
  __typename?: 'MetaData'
  utilityBillCheck?: Maybe<UtilityBillCheck>
}

export type Mutation = {
  __typename?: 'Mutation'
  abortCourtCase: Scalars['Boolean']
  acknowledgeRefreshTokenLanding: RefreshTokenLandingStatus
  addLandlord: Scalars['Boolean']
  addOrUpdateCustomerServiceComment: Scalars['Boolean']
  addOrUpdateServiceComment: Message
  addPrincipalSignatures: Scalars['Boolean']
  addPrincipals: Scalars['Boolean']
  addPurchase: Scalars['Boolean']
  addReferenceNumberToCourtCase: Scalars['Boolean']
  addReferenceNumberToInsuranceClaim: InsuranceClaim
  addScheduledAction: Scalars['Boolean']
  addSelfPaymentAgreement: CustomerDocument
  addServiceNote: Message
  addSpringerCustomer: Scalars['Int']
  addTemplate: Template
  addUsersToGroup: UserGroup
  answerLetterRequest: LetterRequest
  approveMessage: Scalars['Boolean']
  archiveCase: Scalars['Int']
  archiveConflictOfInterest: Scalars['Boolean']
  archiveCourtCase: Scalars['Boolean']
  archivePurchase: Purchase
  askQuestion: Message
  askQuestionForCheckResults: Message
  assignAgentToSupportRequestCases: Scalars['Boolean']
  assignCaseToAgent: Scalars['Boolean']
  assignCourtCaseToAgent: Scalars['Boolean']
  assignCourtCaseToLawyer: Scalars['Boolean']
  assignServiceTaskToAgent: Scalars['Boolean']
  attachDocumentToCustomerMessage: Message
  attachDocumentToLawyerMessage: Message
  attachDocumentsToCustomerMessage: Message
  attachInsuranceClaimToCase: Case
  attachTemplateToMessage: MessageHasTemplate
  batchChangeMembershipLawyer: BatchChangeMembershipLawyerResult
  cancelAppointmentAsAdmin: Scalars['Boolean']
  cancelLetterRequest: LetterRequest
  cancelMembership: Membership
  changeMembershipLawyer: Membership
  changeMembershipNumber: Membership
  clearExpiredAppointmentAsAdmin: Scalars['Int']
  createAdmin: Scalars['Float']
  createConflictOfInterest: CreateConflictOfInterestResult
  createCustomer: Customer
  createCustomerFeedback: CustomerFeedback
  createCustomerServiceTask: ServiceTask
  createInsuranceClaim: InsuranceClaim
  createLawyerHoliday: Scalars['Float']
  /** @deprecated Please use askQuestion mutation */
  createMessage: Message
  createOrUpdateCustomerNote: Scalars['Boolean']
  createOrUpdateMessageForTelesaleAsAdmin: Message
  createOrUpdatePowerOfAttorney: PowerOfAttorney
  createTemplatePdf: CreateTemplatePdfResult
  deleteCustomerAsAdmin: Customer
  deleteInsuranceClaim: InsuranceClaim
  deleteLawyerMessage: Scalars['Int']
  deleteServiceTask: Scalars['Boolean']
  deleteSupportRequest: Scalars['Boolean']
  detachAllCustomerDocuments: Message
  detachDocumentFromCustomerMessage: Message
  detachDocumentFromLawyerMessage: Message
  detachInsuranceClaimFromCase: Case
  downgradeMembership: Scalars['Boolean']
  finalisePowerOfAttorney: Scalars['Boolean']
  generateBookingLinkAsCustomer: GenerateBookingLinkResult
  generateBookingLinkAsCustomerService: GenerateBookingLinkResult
  generateBookingLinkAsInsurancePartner: GenerateBookingLinkResult
  generateBookingLinkAsTelesales: GenerateBookingLinkResult
  generateMeDigitalToken: Scalars['String']
  generateTokenOnRoleChange: AuthSession
  magicLogin: AuthSession
  markInkassoCaseAsUnconfirmed: Scalars['Boolean']
  markInsuranceClaimAsApproved: InsuranceClaim
  markInsuranceClaimAsInvoiced: InsuranceClaim
  markInsuranceClaimAsRejected: InsuranceClaim
  markInsuranceClaimAsRequested: InsuranceClaim
  markInsuranceClaimsAsInvoiced: Scalars['Boolean']
  markMessageAsChecked: Scalars['Boolean']
  openCourtCase: Scalars['Boolean']
  openInvoicesReport: Scalars['String']
  openLetterRequest: LetterRequest
  postponeLetterRequest: LetterRequest
  /** @deprecated Do not archive purchases without revocation */
  purchaseDelete: Scalars['Boolean']
  /** @deprecated Please use addPurchase mutation */
  purchaseSave: Purchase
  refreshAuthToken: RotatedAuthSession
  registerPartnerCustomer: Customer
  removeAnswerLetterRequest: LetterRequest
  removeSpringerCustomer: Scalars['Int']
  removeUsersFromGroup: UserGroup
  requestMembershipCancellation: Scalars['Boolean']
  respondToSupportRequest: Scalars['Boolean']
  restorePurchase: Scalars['Boolean']
  revokeMembershipCancellation: Membership
  revokePreapprovedAppointment: RevokePreapprovedAppointmentMutationResult
  revokePurchase: Scalars['Boolean']
  scheduleNewMembership: Scalars['Boolean']
  sendEmailToCustomer: Scalars['Boolean']
  sendGenericEmail: Scalars['Boolean']
  sendLawyerPortalProblemReport: Scalars['Boolean']
  sendMessageBackToCustomer: Message
  sendMissedAppointmentEmail: Scalars['Boolean']
  sendSuggestAppointmentEmail: Scalars['Boolean']
  sendSupportRequest: Scalars['Boolean']
  sendUpgradeRecommendation: Scalars['Boolean']
  setCustomerDocumentChecked: CustomerDocument
  setDefaultLawyer: Scalars['Int']
  stripeInvoicesDatabaseReport: Scalars['String']
  toggleGlobalFeature: Feature
  toggleUserGroupFeature: Feature
  transitionCourtCase: Scalars['Boolean']
  unapproveMessageAsAdmin: Message
  updateAdmin: Scalars['Float']
  updateCustomerContact: Scalars['Boolean']
  updateCustomerDocument: CustomerDocument
  /** @deprecated Use updateCustomerDocument */
  updateCustomerDocumentAsAdmin: CustomerDocument
  /** @deprecated Use updateCustomerDocument */
  updateCustomerDocumentAsCustomer: CustomerDocument
  updateCustomerFeedback: CustomerFeedback
  updateCustomerFeedbackAsAdmin: CustomerFeedback
  updateInkassoCases: Scalars['Boolean']
  updateInsuranceClaim: InsuranceClaim
  updateLawyerAllocationProbabilities: Array<LawyerAllocationProbability>
  updateLawyerHoliday: Scalars['Float']
  updateMessageAsCustomer: Message
  updateMessageTopic: Scalars['Boolean']
  updateServiceTask: Scalars['Float']
  updateTemplate: Template
  upgradePartnerSubscription: Scalars['Boolean']
  upsertCourtCaseAdminDeadline: CourtCase
  upsertCourtCaseAdminNote: CourtCase
  upsertCourtCaseCoverageRequest: CourtCaseCoverageRequest
  upsertCourtCaseEvent: CourtCaseEvent
  upsertCourtCaseMessage: Message
  upsertCourtCasePaymentEvent: CourtCasePaymentEvent
  upsertCustomerSatisfactionTelephoneSurvey: Scalars['Float']
  upsertCustomerSatisfactionWrittenFormSurvey: Scalars['Float']
  verifyCoverageForInsuranceClaim?: Maybe<CoverageVerificationResult>
  writeLandlord: EmptyResponse
}

export type MutationAbortCourtCaseArgs = {
  input: AbortCourtCaseInput
}

export type MutationAcknowledgeRefreshTokenLandingArgs = {
  clientTabId?: InputMaybe<Scalars['String']>
  refreshTokenReceipt: Scalars['String']
}

export type MutationAddLandlordArgs = {
  landlord: PowerOfAttorneyLandlordInput
}

export type MutationAddOrUpdateCustomerServiceCommentArgs = {
  comment: Scalars['String']
  customerId: Scalars['Int']
}

export type MutationAddOrUpdateServiceCommentArgs = {
  messageId: Scalars['Int']
  text: Scalars['String']
}

export type MutationAddPrincipalSignaturesArgs = {
  principalSignatures: Array<PrincipalSignatureInput>
}

export type MutationAddPrincipalsArgs = {
  input: AddPrincipalsInput
}

export type MutationAddPurchaseArgs = {
  input: AddPurchaseInput
}

export type MutationAddReferenceNumberToCourtCaseArgs = {
  input: AddRerefenceNumberToCourtCaseInput
}

export type MutationAddReferenceNumberToInsuranceClaimArgs = {
  input: AddReferenceNumberToInsuranceClaimInput
}

export type MutationAddScheduledActionArgs = {
  input: AddScheduledActionInput
}

export type MutationAddSelfPaymentAgreementArgs = {
  input: AddSelfPaymentAgreementInput
}

export type MutationAddServiceNoteArgs = {
  messageId: Scalars['Int']
  note: Scalars['String']
}

export type MutationAddSpringerCustomerArgs = {
  input: AddSpringerCustomerInput
}

export type MutationAddTemplateArgs = {
  input: AddTemplateInput
}

export type MutationAddUsersToGroupArgs = {
  input: AddMembersToUserGroupInput
}

export type MutationAnswerLetterRequestArgs = {
  lawyerLetterId: Scalars['Int']
  letterRequestId: Scalars['Int']
}

export type MutationApproveMessageArgs = {
  input: ApproveMessageInput
}

export type MutationArchiveCaseArgs = {
  input: ArchiveCaseInput
}

export type MutationArchiveConflictOfInterestArgs = {
  input: ArchiveConflictOfInterestInput
}

export type MutationArchiveCourtCaseArgs = {
  input: ArchiveCourtCaseInput
}

export type MutationArchivePurchaseArgs = {
  purchaseId: Scalars['Int']
}

export type MutationAskQuestionArgs = {
  input: AskQuestionInput
}

export type MutationAskQuestionForCheckResultsArgs = {
  input: AskQuestionForCheckResultsInput
}

export type MutationAssignAgentToSupportRequestCasesArgs = {
  input: AssignAgentToSupportRequestCasesInput
}

export type MutationAssignCaseToAgentArgs = {
  input: AssignCasesInput
}

export type MutationAssignCourtCaseToAgentArgs = {
  input: AssignCourtCasesInput
}

export type MutationAssignCourtCaseToLawyerArgs = {
  input: AssignCourtCasesToLawyerInput
}

export type MutationAssignServiceTaskToAgentArgs = {
  input: AssignServiceTasksInput
}

export type MutationAttachDocumentToCustomerMessageArgs = {
  documentId: Scalars['Int']
  messageId: Scalars['Int']
}

export type MutationAttachDocumentToLawyerMessageArgs = {
  documentId: Scalars['Int']
  messageId: Scalars['Int']
}

export type MutationAttachDocumentsToCustomerMessageArgs = {
  documentIds: Array<Scalars['Int']>
  messageId: Scalars['Int']
}

export type MutationAttachInsuranceClaimToCaseArgs = {
  input: AttachInsuranceClaimToCaseInput
}

export type MutationAttachTemplateToMessageArgs = {
  messageId: Scalars['Int']
  templateId: Scalars['Int']
}

export type MutationBatchChangeMembershipLawyerArgs = {
  input: BatchChangeMembershipLawyerInput
}

export type MutationCancelAppointmentAsAdminArgs = {
  messageId: Scalars['Int']
}

export type MutationCancelLetterRequestArgs = {
  letterRequestId: Scalars['Int']
}

export type MutationCancelMembershipArgs = {
  input: CancelMembershipInput
}

export type MutationChangeMembershipLawyerArgs = {
  input: ChangeMembershipLawyerInput
}

export type MutationChangeMembershipNumberArgs = {
  input: ChangeMembershipNumberInput
}

export type MutationClearExpiredAppointmentAsAdminArgs = {
  messageId: Scalars['Int']
}

export type MutationCreateAdminArgs = {
  input: CreateAdminInput
}

export type MutationCreateConflictOfInterestArgs = {
  input: CreateConflictOfInterestInput
}

export type MutationCreateCustomerArgs = {
  input: CreateCustomerInput
}

export type MutationCreateCustomerFeedbackArgs = {
  initialFeedback: InitialFeedback
}

export type MutationCreateCustomerServiceTaskArgs = {
  createServiceTaskInputs: CreateServiceTaskInput
}

export type MutationCreateInsuranceClaimArgs = {
  input: CreateInsuranceClaimInput
}

export type MutationCreateLawyerHolidayArgs = {
  input: CreateLawyerHolidayInput
}

export type MutationCreateMessageArgs = {
  newMessage: NewMessage
}

export type MutationCreateOrUpdateCustomerNoteArgs = {
  customerId: Scalars['Int']
  note: Scalars['String']
}

export type MutationCreateOrUpdateMessageForTelesaleAsAdminArgs = {
  newMessage: NewMessageAdmin
}

export type MutationCreateOrUpdatePowerOfAttorneyArgs = {
  powerOfAttorneyBaseInput: PowerOfAttorneyBaseInput
}

export type MutationCreateTemplatePdfArgs = {
  placeholderValues: Scalars['JSON']
  templateUid: Scalars['String']
}

export type MutationDeleteCustomerAsAdminArgs = {
  customerId: Scalars['Int']
}

export type MutationDeleteInsuranceClaimArgs = {
  input: DeleteInsuranceClaimInput
}

export type MutationDeleteLawyerMessageArgs = {
  messageId: Scalars['Int']
}

export type MutationDeleteServiceTaskArgs = {
  serviceTaskId: Scalars['Int']
}

export type MutationDeleteSupportRequestArgs = {
  input: DeleteSupportRequestInput
}

export type MutationDetachAllCustomerDocumentsArgs = {
  messageId: Scalars['Int']
}

export type MutationDetachDocumentFromCustomerMessageArgs = {
  documentId: Scalars['Int']
  messageId: Scalars['Int']
}

export type MutationDetachDocumentFromLawyerMessageArgs = {
  deleteDocuments?: InputMaybe<Scalars['Boolean']>
  documentId: Scalars['Int']
  messageId: Scalars['Int']
}

export type MutationDetachInsuranceClaimFromCaseArgs = {
  input: DetachInsuranceClaimFromCaseInput
}

export type MutationDowngradeMembershipArgs = {
  input: DowngradeMembershipInput
}

export type MutationFinalisePowerOfAttorneyArgs = {
  uid: Scalars['String']
}

export type MutationGenerateBookingLinkAsCustomerArgs = {
  input: GenerateCustomerBookingLinkInput
}

export type MutationGenerateBookingLinkAsCustomerServiceArgs = {
  input: GenerateCustomerBookingLinkInput
}

export type MutationGenerateBookingLinkAsInsurancePartnerArgs = {
  input: GenerateLeadBookingLinkInput
}

export type MutationGenerateBookingLinkAsTelesalesArgs = {
  input: GenerateLeadBookingLinkInput
}

export type MutationGenerateTokenOnRoleChangeArgs = {
  token: Scalars['String']
}

export type MutationMagicLoginArgs = {
  magicLoginToken: Scalars['String']
}

export type MutationMarkInkassoCaseAsUnconfirmedArgs = {
  input: MarkInkassoCaseAsUnconfirmedInput
}

export type MutationMarkInsuranceClaimAsApprovedArgs = {
  input: MarkInsuranceClaimAsApprovedInput
}

export type MutationMarkInsuranceClaimAsInvoicedArgs = {
  input: MarkInsuranceClaimAsInvoicedInput
}

export type MutationMarkInsuranceClaimAsRejectedArgs = {
  input: MarkInsuranceClaimAsRejectedInput
}

export type MutationMarkInsuranceClaimAsRequestedArgs = {
  input: MarkInsuranceClaimAsRequestedInput
}

export type MutationMarkInsuranceClaimsAsInvoicedArgs = {
  input: MarkInsuranceClaimsAsInvoicedInput
}

export type MutationMarkMessageAsCheckedArgs = {
  input: MarkMessageAsCheckedInput
}

export type MutationOpenCourtCaseArgs = {
  input: OpenCourtCaseInput
}

export type MutationOpenLetterRequestArgs = {
  questionId: Scalars['Int']
}

export type MutationPostponeLetterRequestArgs = {
  letterRequestId: Scalars['Int']
}

export type MutationPurchaseDeleteArgs = {
  id: Scalars['Int']
}

export type MutationPurchaseSaveArgs = {
  purchase: PurchaseInput
}

export type MutationRefreshAuthTokenArgs = {
  clientTabId?: InputMaybe<Scalars['String']>
  refreshToken: Scalars['String']
  userId?: InputMaybe<Scalars['Int']>
  userRole?: InputMaybe<UserRoles>
}

export type MutationRegisterPartnerCustomerArgs = {
  input: RegisterPartnerCustomerInput
}

export type MutationRemoveAnswerLetterRequestArgs = {
  lawyerLetterId: Scalars['Int']
}

export type MutationRemoveSpringerCustomerArgs = {
  input: RemoveSpringerCustomerInput
}

export type MutationRemoveUsersFromGroupArgs = {
  input: RemoveMembersFromUserGroupInput
}

export type MutationRequestMembershipCancellationArgs = {
  input: RequestMembershipCancellationInput
}

export type MutationRespondToSupportRequestArgs = {
  input: RespondToSupportRequestInput
}

export type MutationRestorePurchaseArgs = {
  input: RestorePurchaseInput
}

export type MutationRevokeMembershipCancellationArgs = {
  input: RevokeMembershipCancellationInput
}

export type MutationRevokePreapprovedAppointmentArgs = {
  input: RevokePreapprovedAppointmentInput
}

export type MutationRevokePurchaseArgs = {
  input: RevokePurchaseInput
}

export type MutationScheduleNewMembershipArgs = {
  input: ScheduleNewMembershipInput
}

export type MutationSendEmailToCustomerArgs = {
  input: SendEmailToCustomerInput
}

export type MutationSendGenericEmailArgs = {
  input: SendGenericEmailInput
}

export type MutationSendLawyerPortalProblemReportArgs = {
  input: SendLawyerPortalProblemReportInput
}

export type MutationSendMessageBackToCustomerArgs = {
  messageId: Scalars['Int']
}

export type MutationSendMissedAppointmentEmailArgs = {
  input: SendMissedAppointmentEmailInput
}

export type MutationSendSuggestAppointmentEmailArgs = {
  input: SendSuggestAppointmentEmailInput
}

export type MutationSendSupportRequestArgs = {
  input: SendSupportRequestInput
}

export type MutationSendUpgradeRecommendationArgs = {
  input: SendUpgradeRecommendationInput
}

export type MutationSetCustomerDocumentCheckedArgs = {
  setCustomerDocumentCheckInput: SetCustomerDocumentCheckInput
}

export type MutationSetDefaultLawyerArgs = {
  setDefaultLawyerInput: SetDefaultLawyer
}

export type MutationToggleGlobalFeatureArgs = {
  input: ToggleGlobalFeatureInput
}

export type MutationToggleUserGroupFeatureArgs = {
  input: ToggleUserGroupFeatureInput
}

export type MutationTransitionCourtCaseArgs = {
  input: TransitionCourtCaseInput
}

export type MutationUnapproveMessageAsAdminArgs = {
  unapproveMessageAsAdminInput: UnapproveMessageAsAdminInput
}

export type MutationUpdateAdminArgs = {
  input: UpdateAdminInput
}

export type MutationUpdateCustomerContactArgs = {
  input: UpdateCustomerContactInput
}

export type MutationUpdateCustomerDocumentArgs = {
  updateCustomerDocumentInput: UpdateCustomerDocumentInput
}

export type MutationUpdateCustomerDocumentAsAdminArgs = {
  updateCustomerDocumentInput: UpdateCustomerDocumentInput
}

export type MutationUpdateCustomerDocumentAsCustomerArgs = {
  updateCustomerDocumentInput: UpdateCustomerDocumentInput
}

export type MutationUpdateCustomerFeedbackArgs = {
  updatePayload: FeedbackUpdate
}

export type MutationUpdateCustomerFeedbackAsAdminArgs = {
  updateCustomerFeedbackAsAdminInput: UpdateCustomerFeedbackAsAdminInput
}

export type MutationUpdateInkassoCasesArgs = {
  input: Array<UpdateInkassoCaseInput>
}

export type MutationUpdateInsuranceClaimArgs = {
  input: UpdateInsuranceClaimInput
}

export type MutationUpdateLawyerAllocationProbabilitiesArgs = {
  lawyerAllocationGroupInput: LawyerAllocationGroupInput
  lawyerProbabilityInput: Array<LawyerProbabilityInput>
}

export type MutationUpdateLawyerHolidayArgs = {
  input: UpdateLawyerHolidayInput
}

export type MutationUpdateMessageAsCustomerArgs = {
  customerMessageUpdate: CustomerMessageUpdate
}

export type MutationUpdateMessageTopicArgs = {
  input: UpdateMessageTopicInput
}

export type MutationUpdateServiceTaskArgs = {
  serviceTaskId: Scalars['Int']
  updateCustomerServiceTaskInput: UpdateCustomerServiceTaskInput
}

export type MutationUpdateTemplateArgs = {
  input: UpdateTemplateInput
}

export type MutationUpgradePartnerSubscriptionArgs = {
  input: UpgradePartnerSubscriptionInput
}

export type MutationUpsertCourtCaseAdminDeadlineArgs = {
  input: UpsertCourtCaseAdminDeadlineInput
}

export type MutationUpsertCourtCaseAdminNoteArgs = {
  input: UpsertCourtCaseAdminNoteInput
}

export type MutationUpsertCourtCaseCoverageRequestArgs = {
  input: UpsertCourtCaseCoverageRequestInput
}

export type MutationUpsertCourtCaseEventArgs = {
  input: CourtCaseEventInput
}

export type MutationUpsertCourtCaseMessageArgs = {
  input: CourtCaseMessageInput
}

export type MutationUpsertCourtCasePaymentEventArgs = {
  input: CourtCasePaymentEventInput
}

export type MutationUpsertCustomerSatisfactionTelephoneSurveyArgs = {
  input: CustomerSatisfactionTelephoneSurveyInput
}

export type MutationUpsertCustomerSatisfactionWrittenFormSurveyArgs = {
  input: CustomerSatisfactionWrittenFormSurveyInput
}

export type MutationVerifyCoverageForInsuranceClaimArgs = {
  input: VerifyCoverageForInsuranceClaimInput
}

export type MutationWriteLandlordArgs = {
  writeLandlordInput: WriteLandlordInput
}

export type NewMessage = {
  content?: InputMaybe<Scalars['String']>
  customerId: Scalars['Int']
  lawyerId?: InputMaybe<Scalars['Int']>
  letterRequest?: InputMaybe<Scalars['Boolean']>
  messageTypePreference?: InputMaybe<MessageTypePreference>
  topicId: Scalars['Int']
  topicQuestionnaireAnswers?: InputMaybe<Scalars['JSON']>
}

export type NewMessageAdmin = {
  appointmentAt?: InputMaybe<Scalars['DateTime']>
  content?: InputMaybe<Scalars['String']>
  customerId: Scalars['Int']
  lawyerId?: InputMaybe<Scalars['Int']>
  letterRequest?: InputMaybe<Scalars['Boolean']>
  messageTypePreference?: InputMaybe<MessageTypePreference>
  topicId: Scalars['Int']
  topicQuestionnaireAnswers?: InputMaybe<Scalars['JSON']>
}

export type OpenAppointment = {
  __typename?: 'OpenAppointment'
  case?: Maybe<Case>
  courtCase?: Maybe<CourtCase>
  courtCaseUuid?: Maybe<Scalars['ID']>
  customer: Customer
  customerId?: Maybe<Scalars['Int']>
  date?: Maybe<Scalars['DateTime']>
  id: Scalars['ID']
  lawyerId?: Maybe<Scalars['Int']>
  type: OpenAppointmentType
}

export enum OpenAppointmentType {
  Alc = 'ALC',
  CourtCase = 'CourtCase'
}

export type OpenAppointmentsByLawyer = {
  __typename?: 'OpenAppointmentsByLawyer'
  lawyerId: Scalars['ID']
  lawyerLastName: Scalars['String']
  openAppointments: Array<OpenAppointment>
}

export type OpenAppointmentsCollection = {
  __typename?: 'OpenAppointmentsCollection'
  items: Array<OpenAppointment>
  total: Scalars['Int']
}

export type OpenCourtCaseInput = {
  claimCourtCase?: InputMaybe<Scalars['Boolean']>
  customerId: Scalars['Int']
  topicId: Scalars['Int']
}

export type OptionalAddress = {
  __typename?: 'OptionalAddress'
  city?: Maybe<Scalars['String']>
  country?: Maybe<Scalars['String']>
  street?: Maybe<Scalars['String']>
  zip?: Maybe<Scalars['String']>
}

export type OptionalAddressInput = {
  city?: InputMaybe<Scalars['String']>
  country?: InputMaybe<Scalars['String']>
  street?: InputMaybe<Scalars['String']>
  zip?: InputMaybe<Scalars['String']>
}

export enum Outcome {
  Fail = 'Fail',
  Inconclusive = 'Inconclusive',
  Pass = 'Pass'
}

export type PaginationInput = {
  skip?: InputMaybe<Scalars['Int']>
  take?: InputMaybe<Scalars['Int']>
}

export type Partner = {
  __typename?: 'Partner'
  coverageRequestEmail?: Maybe<Scalars['String']>
  fullPartnership: Scalars['Boolean']
  lawyers: Array<Lawyer>
  uid: SubscriptionPartners
}

export type PartnerCustomerData = {
  city?: InputMaybe<Scalars['String']>
  customerType?: InputMaybe<CustomerType>
  email: Scalars['String']
  firstName: Scalars['String']
  gender: Gender
  lastName: Scalars['String']
  phone: Scalars['String']
  street?: InputMaybe<Scalars['String']>
  zip?: InputMaybe<Scalars['String']>
}

export enum PartnerProductType {
  Adac = 'ADAC',
  Advocard = 'ADVOCARD',
  AdvocardAiChecks = 'ADVOCARD_AI_CHECKS',
  AdvocardPrevention = 'ADVOCARD_PREVENTION',
  Allianz = 'ALLIANZ',
  Arag = 'ARAG',
  Auxilia = 'AUXILIA',
  Badische = 'BADISCHE',
  Concordia = 'CONCORDIA',
  Continentale = 'CONTINENTALE',
  Debeka = 'DEBEKA',
  Deurag = 'DEURAG',
  Devk = 'DEVK',
  Dmb = 'DMB',
  Ergo = 'ERGO',
  HukCoburg = 'HUK_COBURG',
  Immoscout24 = 'IMMOSCOUT24',
  Itzehoer = 'ITZEHOER',
  Klugo = 'KLUGO',
  Lvm = 'LVM',
  Mecklenburgische = 'MECKLENBURGISCHE',
  NeueRechtsschutz = 'NEUE_RECHTSSCHUTZ',
  Oerag = 'OERAG',
  Roland = 'ROLAND',
  RPlusV = 'R_PLUS_V',
  Vgh = 'VGH',
  Wgv = 'WGV',
  Wuerttembergische = 'WUERTTEMBERGISCHE'
}

export type PartnerUidFilter = {
  equals?: InputMaybe<SubscriptionPartners>
  in?: InputMaybe<Array<SubscriptionPartners>>
  not_equals?: InputMaybe<SubscriptionPartners>
  not_in?: InputMaybe<Array<SubscriptionPartners>>
}

export type PartnersListFilterInput = {
  uid?: InputMaybe<PartnerUidFilter>
}

export type PartnersListSortInput = {
  uid?: InputMaybe<SortDirection>
}

export enum PaymentMethod {
  BankTransfer = 'BankTransfer',
  CreditCard = 'CreditCard',
  DirectDebit = 'DirectDebit',
  MasterCard = 'MasterCard',
  PaidByPartner = 'PaidByPartner',
  PayPal = 'PayPal',
  Stripe = 'Stripe',
  Visa = 'Visa'
}

export type PaymentMethodFilter = {
  equals?: InputMaybe<PaymentMethod>
  in?: InputMaybe<Array<PaymentMethod>>
  not_equals?: InputMaybe<PaymentMethod>
  not_in?: InputMaybe<Array<PaymentMethod>>
}

export type PowerOfAttorney = {
  __typename?: 'PowerOfAttorney'
  customerDocument?: Maybe<CustomerDocument>
  deliveryMethod: DeliveryMethod
  landlord?: Maybe<PowerOfAttorneyLandlord>
  letterRequest?: Maybe<LetterRequest>
  principals?: Maybe<Array<PowerOfAttorneyPrincipal>>
  state: PowerOfAttorneyState
  uid: Scalars['String']
}

export type PowerOfAttorneyBaseInput = {
  customerDocumentId?: InputMaybe<Scalars['Float']>
  deliveryMethod?: InputMaybe<DeliveryMethod>
  letterRequestId?: InputMaybe<Scalars['Float']>
  state?: InputMaybe<PowerOfAttorneyState>
  uid?: InputMaybe<Scalars['String']>
}

export type PowerOfAttorneyLandlord = {
  __typename?: 'PowerOfAttorneyLandlord'
  city: Scalars['String']
  fullName: Scalars['String']
  postalCode: Scalars['String']
  streetAddress: Scalars['String']
}

export type PowerOfAttorneyLandlordInput = {
  city: Scalars['String']
  fullName: Scalars['String']
  postalCode: Scalars['String']
  powerOfAttorneyUid: Scalars['String']
  streetAddress: Scalars['String']
}

export type PowerOfAttorneyListFilterInput = {
  uid?: InputMaybe<StringFilter>
}

export type PowerOfAttorneyListSortInput = {
  uid?: InputMaybe<SortDirection>
}

export type PowerOfAttorneyPrincipal = {
  __typename?: 'PowerOfAttorneyPrincipal'
  firstName: Scalars['String']
  lastName: Scalars['String']
  signature?: Maybe<PrincipalSignature>
  uid: Scalars['String']
}

export enum PowerOfAttorneyState {
  DocumentGenerated = 'DocumentGenerated',
  DocumentSent = 'DocumentSent',
  LandlordDataAdded = 'LandlordDataAdded',
  PrincipalDataAdded = 'PrincipalDataAdded',
  Requested = 'Requested',
  SignaturesCollected = 'SignaturesCollected'
}

export enum Prediction {
  Inconclusive = 'Inconclusive',
  NotOk = 'NotOk',
  Ok = 'Ok',
  Questionable = 'Questionable'
}

export type PrincipalInput = {
  firstName: Scalars['String']
  lastName: Scalars['String']
  uid?: InputMaybe<Scalars['String']>
}

export type PrincipalSignature = {
  __typename?: 'PrincipalSignature'
  location: Scalars['String']
  signatureDate: Scalars['String']
  signatureImage: Scalars['String']
}

export type PrincipalSignatureInput = {
  location: Scalars['String']
  signature: Scalars['String']
  uid: Scalars['String']
}

export type Product = {
  __typename?: 'Product'
  archived: Scalars['Boolean']
  category: ProductCategory
  description?: Maybe<Scalars['String']>
  downgradesFrom?: Maybe<Array<Scalars['Int']>>
  id: Scalars['Int']
  lawyerAmount: Scalars['Int']
  lawyerOption?: Maybe<LawyerOption>
  letterPerMembershipYear: Scalars['Int']
  membershipTypeUid?: Maybe<Scalars['ID']>
  mieterengelAmount: Scalars['Int']
  name: Scalars['String']
  productOption?: Maybe<ProductOption>
  productOverview?: Maybe<Scalars['String']>
  productOverviewText?: Maybe<Scalars['String']>
  productTemplate?: Maybe<ProductTemplate>
  recurring: Scalars['Boolean']
  recurringLawyer: Scalars['Int']
  recurringMieterengel: Scalars['Int']
  registrationFeeAmount?: Maybe<Scalars['Int']>
  route?: Maybe<Scalars['String']>
  type: Scalars['String']
  upgradesFrom?: Maybe<Array<Scalars['Int']>>
  upgradesTo?: Maybe<Array<Scalars['Int']>>
}

export enum ProductCategory {
  Membership = 'Membership',
  Partnership = 'Partnership',
  Single = 'Single',
  Upgrade = 'Upgrade'
}

export type ProductCategoryFilter = {
  equals?: InputMaybe<ProductCategory>
  in?: InputMaybe<Array<ProductCategory>>
  not_equals?: InputMaybe<ProductCategory>
  not_in?: InputMaybe<Array<ProductCategory>>
}

export type ProductOption = {
  __typename?: 'ProductOption'
  contactPerson: Scalars['Boolean']
  freePatterns: Scalars['Boolean']
  supervision?: Maybe<Scalars['Boolean']>
  tenantProtection?: Maybe<TenantProtection>
}

export type ProductTemplate = {
  __typename?: 'ProductTemplate'
  backgroundImage: Scalars['String']
  color: Scalars['String']
  icon: ProductTemplateIcon
}

export enum ProductTemplateIcon {
  BasisIcon = 'basisIcon',
  MietvertragscheckIcon = 'mietvertragscheckIcon',
  PlusIcon = 'plusIcon',
  PremiumIcon = 'premiumIcon',
  ProIcon = 'proIcon',
  RenovierungsklauselcheckIcon = 'renovierungsklauselcheckIcon',
  ZweischreibenIcon = 'zweischreibenIcon'
}

export type ProductsCollection = {
  __typename?: 'ProductsCollection'
  first?: Maybe<Product>
  items: Array<Product>
  last?: Maybe<Product>
  skip?: Maybe<Scalars['Int']>
  take?: Maybe<Scalars['Int']>
  total: Scalars['Int']
}

export type ProductsListFilterInput = {
  archived?: InputMaybe<BooleanFilter>
  category?: InputMaybe<ProductCategoryFilter>
  downgradesFrom?: InputMaybe<ArrayIntFilter>
  id?: InputMaybe<IntFilter>
  lawyerId?: InputMaybe<ArrayIntFilter>
  route?: InputMaybe<StringFilter>
  type?: InputMaybe<StringFilter>
  upgradesTo?: InputMaybe<ArrayIntFilter>
}

export type ProductsListSortInput = {
  createdAt?: InputMaybe<SortDirection>
  updatedAt?: InputMaybe<SortDirection>
}

export enum ProfessionalAuditOutcome {
  Fail = 'Fail',
  Inconclusive = 'Inconclusive',
  Pass = 'Pass'
}

export type ProfessionalAuditReport = {
  __typename?: 'ProfessionalAuditReport'
  auditType: ProfessionalAuditType
  sections: Array<ProfessionalAuditSection>
}

export type ProfessionalAuditSection = {
  __typename?: 'ProfessionalAuditSection'
  checks?: Maybe<Array<ProfessionalAuditSection>>
  label?: Maybe<Scalars['String']>
  outcome?: Maybe<ProfessionalAuditOutcome>
  summary: Scalars['JSON']
  uid: Scalars['String']
}

export enum ProfessionalAuditType {
  AdvocardRenovationClauseAudit = 'AdvocardRenovationClauseAudit',
  AdvocardUtilityBillAudit = 'AdvocardUtilityBillAudit',
  RoutineStandardAudit = 'RoutineStandardAudit',
  RoutineUtilityBillAudit = 'RoutineUtilityBillAudit'
}

export type Purchase = {
  __typename?: 'Purchase'
  autoRenewal: Scalars['Boolean']
  cases?: Maybe<Array<Case>>
  createdAt: Scalars['DateTime']
  customer?: Maybe<Customer>
  customerId?: Maybe<Scalars['Int']>
  id: Scalars['Int']
  invoices: Array<PurchaseInvoice>
  ipAddress?: Maybe<Scalars['String']>
  isArchived: Scalars['Boolean']
  lawyer?: Maybe<Lawyer>
  lawyerId?: Maybe<Scalars['Int']>
  paid: Scalars['Boolean']
  paymentMethod: PaymentMethod
  product?: Maybe<Product>
  productId?: Maybe<Scalars['Int']>
  referredBy?: Maybe<Scalars['String']>
  subscription?: Maybe<StripeSubscription>
  updatedAt: Scalars['DateTime']
}

export type PurchaseInput = {
  autoRenewal?: InputMaybe<Scalars['Boolean']>
  customerId?: InputMaybe<Scalars['Int']>
  id?: InputMaybe<Scalars['Int']>
  ipAddress?: InputMaybe<Scalars['String']>
  isArchived?: InputMaybe<Scalars['Boolean']>
  lawyerId?: InputMaybe<Scalars['Int']>
  paid?: InputMaybe<Scalars['Boolean']>
  paymentMethod: PaymentMethod
  referredBy?: InputMaybe<Scalars['String']>
  subscriptionId?: InputMaybe<Scalars['Int']>
}

export type PurchaseInvoice = {
  __typename?: 'PurchaseInvoice'
  collectionMethod: StripeInvoiceCollectionMethod
  createdAt: Scalars['DateTime']
  disputedAt?: Maybe<Scalars['DateTime']>
  finalizedAt?: Maybe<Scalars['DateTime']>
  id: Scalars['ID']
  inkassoCase?: Maybe<InkassoCase>
  invoiceAmount: Scalars['Float']
  invoiceNumber: Scalars['String']
  paidAt?: Maybe<Scalars['DateTime']>
  paymentDeferredByAdmin?: Maybe<Admin>
  paymentDeferredUntil?: Maybe<Scalars['DateTime']>
  refundedAt?: Maybe<Scalars['DateTime']>
  status?: Maybe<StripeInvoiceStatus>
  voidedAt?: Maybe<Scalars['DateTime']>
}

export type PurchaseReportEntryKpi = {
  __typename?: 'PurchaseReportEntryKpi'
  productType: Scalars['String']
  purchases: Scalars['Int']
}

export type PurchaseReportFilterKpi = {
  endDate: Scalars['DateTime']
  productTypes: Array<Scalars['String']>
  startDate: Scalars['DateTime']
}

export type PurchaseReportKpi = {
  __typename?: 'PurchaseReportKpi'
  entries: Array<PurchaseReportEntryKpi>
  totals: PurchaseReportTotalsKpi
}

export type PurchaseReportTotalsKpi = {
  __typename?: 'PurchaseReportTotalsKpi'
  purchases: Scalars['Int']
}

export type PurchasesCollection = {
  __typename?: 'PurchasesCollection'
  first?: Maybe<Purchase>
  items: Array<Purchase>
  last?: Maybe<Purchase>
  skip?: Maybe<Scalars['Int']>
  take?: Maybe<Scalars['Int']>
  total: Scalars['Int']
}

export type PurchasesListFilterInput = {
  customerId?: InputMaybe<IntFilter>
  id?: InputMaybe<IntFilter>
  isArchived?: InputMaybe<BooleanFilter>
  lawyerId?: InputMaybe<IntFilter>
  paymentMethod?: InputMaybe<PaymentMethodFilter>
  productCategory?: InputMaybe<ProductCategoryFilter>
  productId?: InputMaybe<IntFilter>
}

export type PurchasesListSortInput = {
  createdAt?: InputMaybe<SortDirection>
  updatedAt?: InputMaybe<SortDirection>
}

export type Query = {
  __typename?: 'Query'
  admin: Admin
  admins: AdminsCollection
  appointmentsAsAdmin: Array<OpenAppointmentsByLawyer>
  cases: CasesCollection
  checkIfServiceIsUsable: CheckIfServiceIsUsableResult
  conflictsOfInterest: ConflictsOfInterestCollection
  /** @deprecated User latest case state instead */
  conversation: Conversation
  countCases: Scalars['Int']
  countCourtCases: Scalars['Int']
  countCustomers: Scalars['Int']
  countInsuranceClaims: Scalars['Int']
  countLeadTasks: Scalars['Int']
  countLeads: Scalars['Int']
  countOpenAppointments: Scalars['Int']
  countPostponedRequestsForLawyer: Scalars['Int']
  countSupportRequestCases: Scalars['Int']
  countTemplateCollections: Scalars['Int']
  courtCaseCoverageRequests: Array<CourtCaseCoverageRequest>
  courtCases: CourtCasesCollection
  customer: Customer
  customerAlreadySpringer: Scalars['Boolean']
  /** @deprecated Use customer resolver */
  customerAsAdmin: Customer
  customerDocument: CustomerDocument
  customerDocumentCategories: Array<CustomerDocumentCategory>
  customerDocuments: Array<CustomerDocument>
  /** @deprecated Use customer resolver */
  customerExistsAsAdmin: Customer
  /** @deprecated Use customer.hasPayment resolver */
  customerHasPayment: Scalars['Boolean']
  customerSatisfactionTelephoneSurvey?: Maybe<CustomerSatisfactionTelephoneSurvey>
  customerSatisfactionWrittenFormSurvey?: Maybe<CustomerSatisfactionWrittenFormSurvey>
  customerServiceTasks: Array<ServiceTask>
  customers: CustomersCollection
  defaultFeatures: Array<FeatureFlag>
  defaultLawyer: Lawyer
  emailTemplate: Array<EmailTemplate>
  features: Array<Feature>
  /** @deprecated User admins resolver */
  getAdmins: Array<Admin>
  getCustomerFeedback?: Maybe<CustomerFeedback>
  /** @deprecated use lawyers() resolver */
  getLawyers: Array<Lawyer>
  getSpringerCustomers: Array<AppointmentSpringer>
  globalReportKpi: GlobalReportKpi
  informationMaterial: InformationMaterial
  insuranceClaimServices: InsuranceClaimServicesCollection
  insuranceClaims: InsuranceClaimsCollection
  latestCustomerFeedback?: Maybe<CustomerFeedback>
  lawyer: Lawyer
  lawyerAllocationProbabilities: Array<LawyerAllocationProbability>
  lawyerCustomerInteractions: Array<LawyerCustomerInteraction>
  lawyerDocumentsAsLawyer: Array<LawyerDocument>
  lawyerDocumentsByCustomer: Array<LawyerDocument>
  lawyerHolidays: LawyerHolidaysCollection
  lawyerReportKpi: LawyerReportKpi
  lawyers: LawyersCollection
  leadTasks: LeadTasksCollection
  leads: LeadsCollection
  /** @deprecated Use customer.letterAlloance and message.letterRequest resolvers */
  letterRequestsForCustomer: LetterRequestForCustomer
  me: Customer
  messageTopics: Array<Topic>
  myLawyerInformation: Lawyer
  openAppointments: OpenAppointmentsCollection
  partner: Partner
  partners: Array<Partner>
  postponedRequestsForLawyer: Array<LetterRequest>
  powerOfAttorney: PowerOfAttorney
  product: Product
  products: ProductsCollection
  purchase: Purchase
  purchaseReportKpi: PurchaseReportKpi
  purchases: Array<Purchase>
  recentCustomerFeedbackList?: Maybe<CustomerFeedbackList>
  referenceNumberExists: Scalars['Boolean']
  salesAgentReportKpi: SalesAgentReportKpi
  serviceAgentReportKpi: ServiceAgentReportKpi
  serviceConfigs: ServiceConfigCollection
  serviceTaskGroups: Array<ServiceTaskGroup>
  serviceTasks: ServiceTaskCollection
  supportRequestCases: SupportRequestCasesCollection
  templateCollection: TemplateCollection
  templateCollections: TemplateCollectionsCollection
  /** @deprecated Use me resolver */
  userData: Customer
  userGroup: UserGroup
  userGroups: Array<UserGroup>
  utilityBillResults: UtilityBillResults
}

export type QueryAdminArgs = {
  id: Scalars['Int']
}

export type QueryAdminsArgs = {
  filters: AdminsListFilterInput
  multiSortOrder?: InputMaybe<AdminsListMultiSortOrderInput>
  pagination?: InputMaybe<PaginationInput>
  sorts?: InputMaybe<AdminsListSortInput>
}

export type QueryAppointmentsAsAdminArgs = {
  from?: InputMaybe<Scalars['String']>
}

export type QueryCasesArgs = {
  filters: CasesListFilterInput
  pagination?: InputMaybe<PaginationInput>
  sorts?: InputMaybe<CasesListSortInput>
}

export type QueryCheckIfServiceIsUsableArgs = {
  input: CheckIfServiceIsUsableInput
}

export type QueryConflictsOfInterestArgs = {
  filters: ConflictsOfInterestListFilterInput
  pagination?: InputMaybe<PaginationInput>
  sorts?: InputMaybe<ConflictsOfInterestListSortInput>
}

export type QueryCountCasesArgs = {
  filters: CasesListFilterInput
}

export type QueryCountCourtCasesArgs = {
  filters: CourtCasesListFilterInput
}

export type QueryCountCustomersArgs = {
  filters: CustomersListFilterInput
  sorts?: InputMaybe<CustomersListSortInput>
}

export type QueryCountInsuranceClaimsArgs = {
  filters: InsuranceClaimsListFilterInput
  sorts?: InputMaybe<InsuranceClaimsListSortInput>
}

export type QueryCountLeadTasksArgs = {
  filters: LeadTasksListFilterInput
  sorts?: InputMaybe<LeadTasksListSortInput>
}

export type QueryCountLeadsArgs = {
  filters: LeadsListFilterInput
  sorts?: InputMaybe<LeadsListSortInput>
}

export type QueryCountSupportRequestCasesArgs = {
  filters: SupportRequestCasesListFilterInput
}

export type QueryCountTemplateCollectionsArgs = {
  filters: TemplateCollectionsListFilterInput
}

export type QueryCourtCaseCoverageRequestsArgs = {
  filters?: InputMaybe<CourtCaseCoverageRequestsListFilterInput>
}

export type QueryCourtCasesArgs = {
  filters: CourtCasesListFilterInput
  pagination?: InputMaybe<PaginationInput>
  sorts?: InputMaybe<CourtCasesListSortInput>
}

export type QueryCustomerArgs = {
  email?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['Int']>
  membershipNumber?: InputMaybe<Scalars['String']>
}

export type QueryCustomerAlreadySpringerArgs = {
  customerId: Scalars['Int']
}

export type QueryCustomerAsAdminArgs = {
  customerId: Scalars['Int']
}

export type QueryCustomerDocumentArgs = {
  customerDocumentId: Scalars['Int']
}

export type QueryCustomerDocumentsArgs = {
  customerId: Scalars['Int']
}

export type QueryCustomerExistsAsAdminArgs = {
  customer: CustomerExistsAsAdminInput
}

export type QueryCustomerHasPaymentArgs = {
  customerId: Scalars['Int']
}

export type QueryCustomerSatisfactionTelephoneSurveyArgs = {
  answerMessageId: Scalars['Int']
}

export type QueryCustomerSatisfactionWrittenFormSurveyArgs = {
  answerMessageId: Scalars['Int']
}

export type QueryCustomerServiceTasksArgs = {
  customerId: Scalars['Int']
}

export type QueryCustomersArgs = {
  filters: CustomersListFilterInput
  pagination?: InputMaybe<PaginationInput>
  sorts?: InputMaybe<CustomersListSortInput>
}

export type QueryDefaultLawyerArgs = {
  productId?: InputMaybe<Scalars['Int']>
}

export type QueryEmailTemplateArgs = {
  getEmailTemplateInput: GetEmailTemplateInput
}

export type QueryGetCustomerFeedbackArgs = {
  id: Scalars['Int']
}

export type QueryGlobalReportKpiArgs = {
  filter: GlobalReportFilterKpi
}

export type QueryInsuranceClaimServicesArgs = {
  filters: InsuranceClaimServicesListFilterInput
  pagination?: InputMaybe<PaginationInput>
  sorts?: InputMaybe<InsuranceClaimServicesListSortInput>
}

export type QueryInsuranceClaimsArgs = {
  filters: InsuranceClaimsListFilterInput
  pagination?: InputMaybe<PaginationInput>
  sorts?: InputMaybe<InsuranceClaimsListSortInput>
}

export type QueryLatestCustomerFeedbackArgs = {
  messageId: Scalars['Int']
}

export type QueryLawyerArgs = {
  id: Scalars['Int']
}

export type QueryLawyerAllocationProbabilitiesArgs = {
  input: LawyerAllocationGroupInput
}

export type QueryLawyerCustomerInteractionsArgs = {
  limit: Scalars['Int']
}

export type QueryLawyerDocumentsByCustomerArgs = {
  customerId: Scalars['Int']
}

export type QueryLawyerHolidaysArgs = {
  filters: LawyerHolidaysListFilterInput
  pagination?: InputMaybe<PaginationInput>
  sorts?: InputMaybe<LawyerHolidaysListSortInput>
}

export type QueryLawyerReportKpiArgs = {
  filter: LawyerReportFilterKpi
}

export type QueryLawyersArgs = {
  filters?: InputMaybe<LawyersListFilterInput>
  pagination?: InputMaybe<PaginationInput>
  sorts?: InputMaybe<LawyersListSortInput>
}

export type QueryLeadTasksArgs = {
  filters: LeadTasksListFilterInput
  pagination?: InputMaybe<PaginationInput>
  sorts?: InputMaybe<LeadTasksListSortInput>
}

export type QueryLeadsArgs = {
  filters: LeadsListFilterInput
  pagination?: InputMaybe<PaginationInput>
  sorts?: InputMaybe<LeadsListSortInput>
}

export type QueryLetterRequestsForCustomerArgs = {
  customerId: Scalars['Int']
}

export type QueryPartnerArgs = {
  filters?: InputMaybe<PartnersListFilterInput>
  sorts?: InputMaybe<PartnersListSortInput>
}

export type QueryPartnersArgs = {
  filters?: InputMaybe<PartnersListFilterInput>
}

export type QueryPowerOfAttorneyArgs = {
  filters?: InputMaybe<PowerOfAttorneyListFilterInput>
  sorts?: InputMaybe<PowerOfAttorneyListSortInput>
}

export type QueryProductArgs = {
  id: Scalars['Int']
}

export type QueryProductsArgs = {
  filters: ProductsListFilterInput
  pagination?: InputMaybe<PaginationInput>
  sorts?: InputMaybe<ProductsListSortInput>
}

export type QueryPurchaseArgs = {
  id: Scalars['Int']
}

export type QueryPurchaseReportKpiArgs = {
  filter: PurchaseReportFilterKpi
}

export type QueryPurchasesArgs = {
  customerId: Scalars['Int']
  includeArchived?: InputMaybe<Scalars['Boolean']>
}

export type QueryReferenceNumberExistsArgs = {
  insuranceClaimPartner: InsuranceClaimPartner
  referenceNumber: Scalars['String']
}

export type QuerySalesAgentReportKpiArgs = {
  filter: SalesAgentReportFilterKpi
}

export type QueryServiceAgentReportKpiArgs = {
  filter: ServiceAgentReportFilterKpi
}

export type QueryServiceConfigsArgs = {
  filters: ServiceConfigListFilterInput
  pagination?: InputMaybe<PaginationInput>
  sorts?: InputMaybe<ServiceConfigListSortInput>
}

export type QueryServiceTaskGroupsArgs = {
  filters: ServiceTaskListFilterInput
  groupType: ServiceTaskGroupType
  pagination?: InputMaybe<PaginationInput>
  sorts?: InputMaybe<ServiceTaskListSortInput>
}

export type QueryServiceTasksArgs = {
  filters: ServiceTaskListFilterInput
  pagination?: InputMaybe<PaginationInput>
  sorts?: InputMaybe<ServiceTaskListSortInput>
}

export type QuerySupportRequestCasesArgs = {
  filters: SupportRequestCasesListFilterInput
  pagination?: InputMaybe<PaginationInput>
  sorts?: InputMaybe<SupportRequestCasesListSortInput>
}

export type QueryTemplateCollectionArgs = {
  filters?: InputMaybe<TemplateCollectionsListFilterInput>
  sorts?: InputMaybe<TemplateCollectionsListSortInput>
}

export type QueryTemplateCollectionsArgs = {
  filters?: InputMaybe<TemplateCollectionsListFilterInput>
  pagination?: InputMaybe<PaginationInput>
  sorts?: InputMaybe<TemplateCollectionsListSortInput>
}

export type QueryUserGroupArgs = {
  id?: InputMaybe<Scalars['Int']>
  name?: InputMaybe<Scalars['String']>
}

export type RecentCustomerFeedback = {
  __typename?: 'RecentCustomerFeedback'
  customerId: Scalars['Float']
  date: Scalars['DateTime']
  firstName: Scalars['String']
  id: Scalars['Float']
  lastName: Scalars['String']
  lastProduct?: Maybe<Product>
  membershipType?: Maybe<MembershipType>
  phoneNumber?: Maybe<Scalars['String']>
  rating: Scalars['Float']
}

export enum RefreshTokenLandingStatus {
  AlreadySuperseded = 'AlreadySuperseded',
  Landed = 'Landed',
  NotFound = 'NotFound'
}

export type RegisterPartnerCustomerInput = {
  customerData: PartnerCustomerData
  insuranceClaimPayload?: InputMaybe<InsuranceClaimPayload>
  insuranceNumber?: InputMaybe<Scalars['String']>
  lawyerId: Scalars['Int']
  partner: SubscriptionPartners
  productType: PartnerProductType
}

export type RemoveMembersFromUserGroupInput = {
  groupId: Scalars['Int']
  members: Array<UserGroupMemberInput>
}

export type RemoveSpringerCustomerInput = {
  customerId: Scalars['Float']
  messageId: Scalars['Float']
}

export type Reporter = Admin | Lawyer

export type RequestMembershipCancellationInput = {
  cancellationReason?: InputMaybe<Scalars['String']>
}

export type RequiredAddress = {
  __typename?: 'RequiredAddress'
  city: Scalars['String']
  country: Scalars['String']
  street: Scalars['String']
  zip: Scalars['String']
}

export type RespondToSupportRequestInput = {
  content: Scalars['JSON']
  responseToId: Scalars['Int']
}

export type RestorePurchaseInput = {
  purchaseId: Scalars['Int']
}

export type RevokeMembershipCancellationInput = {
  uuid: Scalars['ID']
}

export type RevokePreapprovedAppointmentInput = {
  messageId: Scalars['Int']
  messageToCustomer: Scalars['JSON']
}

export type RevokePreapprovedAppointmentMutationResult = {
  __typename?: 'RevokePreapprovedAppointmentMutationResult'
  externalBookingCancelled: Scalars['Boolean']
}

export type RevokePurchaseInput = {
  purchaseId: Scalars['Int']
}

export type RotatedAuthSession = {
  __typename?: 'RotatedAuthSession'
  refreshToken: Scalars['String']
  refreshTokenReceipt: Scalars['String']
  token: Scalars['String']
}

export type SalesAgentReportEntryKpi = {
  __typename?: 'SalesAgentReportEntryKpi'
  salesAgentId: Scalars['Int']
  telesales: Scalars['Int']
}

export type SalesAgentReportFilterKpi = {
  endDate: Scalars['DateTime']
  salesAgentIds: Array<Scalars['Int']>
  startDate: Scalars['DateTime']
}

export type SalesAgentReportKpi = {
  __typename?: 'SalesAgentReportKpi'
  entries: Array<SalesAgentReportEntryKpi>
  totals: SalesAgentReportTotalsKpi
}

export type SalesAgentReportTotalsKpi = {
  __typename?: 'SalesAgentReportTotalsKpi'
  telesales: Scalars['Int']
}

export type ScheduleNewMembershipInput = {
  advancedFromUuid?: InputMaybe<Scalars['String']>
  customerId: Scalars['Int']
  forceSendInvoice: Scalars['Boolean']
  lawyerId: Scalars['Int']
  productId: Scalars['Int']
  startsAt?: InputMaybe<Scalars['DateTime']>
  stripePaymentMethodId?: InputMaybe<Scalars['String']>
}

export type SendEmailToCustomerInput = {
  dueDate?: InputMaybe<Scalars['DateTime']>
  messageId: Scalars['Float']
  messageToCustomer: Scalars['JSON']
  reason: SendEmailToCustomerReason
}

export enum SendEmailToCustomerReason {
  CallbackRequested = 'CallbackRequested',
  DocumentsRequested = 'DocumentsRequested',
  InformationEmail = 'InformationEmail'
}

export type SendGenericEmailInput = {
  customerId: Scalars['Float']
  messageToCustomer: Scalars['JSON']
}

export type SendLawyerPortalProblemReportInput = {
  message: Scalars['String']
}

export type SendMissedAppointmentEmailInput = {
  messageId: Scalars['Int']
}

export type SendSuggestAppointmentEmailInput = {
  messageId: Scalars['Float']
}

export type SendSupportRequestInput = {
  content: Scalars['String']
}

export type SendUpgradeRecommendationInput = {
  customerId: Scalars['Float']
  lawyerId: Scalars['Float']
  productId: Scalars['Float']
}

export type Service = {
  __typename?: 'Service'
  createdAt: Scalars['DateTime']
  feature?: Maybe<Feature>
  featureId?: Maybe<Scalars['Int']>
  quota?: Maybe<Scalars['Int']>
  uid: Scalars['String']
  updatedAt: Scalars['DateTime']
}

export type ServiceAgentReportEntryKpi = {
  __typename?: 'ServiceAgentReportEntryKpi'
  averageTimeToFirstAction: Scalars['Float']
  serviceActions: Scalars['Int']
  serviceAgentId: Scalars['Int']
}

export type ServiceAgentReportFilterKpi = {
  endDate: Scalars['DateTime']
  serviceAgentIds: Array<Scalars['Int']>
  startDate: Scalars['DateTime']
}

export type ServiceAgentReportKpi = {
  __typename?: 'ServiceAgentReportKpi'
  entries: Array<ServiceAgentReportEntryKpi>
  totals: ServiceAgentReportTotalsKpi
}

export type ServiceAgentReportTotalsKpi = {
  __typename?: 'ServiceAgentReportTotalsKpi'
  averageTimeToFirstAction: Scalars['Float']
  serviceActions: Scalars['Int']
}

export type ServiceComment = {
  __typename?: 'ServiceComment'
  comment: Scalars['String']
  createdAt: Scalars['DateTime']
  id: Scalars['Int']
  name: Scalars['String']
  updatedAt: Scalars['DateTime']
}

export type ServiceConfig = {
  __typename?: 'ServiceConfig'
  defaultOption?: Maybe<Scalars['Boolean']>
  event: Scalars['String']
  icCreationOption?: Maybe<Scalars['String']>
  membershipTypeUid: Scalars['String']
  registrationOption?: Maybe<Scalars['String']>
  serviceUid: Scalars['String']
  uuid: Scalars['ID']
}

export type ServiceConfigCollection = {
  __typename?: 'ServiceConfigCollection'
  first?: Maybe<ServiceConfig>
  items: Array<ServiceConfig>
  last?: Maybe<ServiceConfig>
  skip?: Maybe<Scalars['Int']>
  take?: Maybe<Scalars['Int']>
  total: Scalars['Int']
}

export type ServiceConfigListFilterInput = {
  membershipTypeUid?: InputMaybe<StringFilter>
  optionsFor?: InputMaybe<StringFilter>
}

export type ServiceConfigListSortInput = {
  createdAt?: InputMaybe<SortDirection>
  updatedAt?: InputMaybe<SortDirection>
}

export type ServicePeriod = {
  __typename?: 'ServicePeriod'
  end?: Maybe<Scalars['String']>
  start?: Maybe<Scalars['String']>
}

export type ServicePeriodCheck = {
  __typename?: 'ServicePeriodCheck'
  conditions: Array<Condition>
  context: ServicePeriodContext
  name: UtilityBillCheckName
  outcome: Outcome
}

export type ServicePeriodContext = {
  __typename?: 'ServicePeriodContext'
  values: ServicePeriodContextValues
}

export type ServicePeriodContextValues = {
  __typename?: 'ServicePeriodContextValues'
  servicePeriodEnd?: Maybe<Scalars['String']>
  servicePeriodStart?: Maybe<Scalars['String']>
}

export type ServiceTask = {
  __typename?: 'ServiceTask'
  assignedAgent?: Maybe<Admin>
  assignedAgentId?: Maybe<Scalars['Int']>
  checked?: Maybe<Scalars['Boolean']>
  createdAt: Scalars['DateTime']
  customer: Customer
  customerId: Scalars['Int']
  description?: Maybe<Scalars['String']>
  dueDate: Scalars['DateTime']
  firstEmailSent?: Maybe<Scalars['DateTime']>
  id: Scalars['Int']
  messageId?: Maybe<Scalars['Int']>
  title: Scalars['String']
  type: Scalars['String']
  updatedAt: Scalars['DateTime']
}

export type ServiceTaskCollection = {
  __typename?: 'ServiceTaskCollection'
  first?: Maybe<ServiceTask>
  items: Array<ServiceTask>
  last?: Maybe<ServiceTask>
  skip?: Maybe<Scalars['Int']>
  take?: Maybe<Scalars['Int']>
  total: Scalars['Int']
}

export type ServiceTaskGroup = {
  __typename?: 'ServiceTaskGroup'
  id: Scalars['String']
  items: Array<ServiceTask>
}

export enum ServiceTaskGroupType {
  DueDateAsc = 'DueDateAsc'
}

export type ServiceTaskListFilterInput = {
  assignedAgentId?: InputMaybe<IntFilter>
  checked?: InputMaybe<BooleanFilter>
  dueDate?: InputMaybe<DateFilter>
  mainType?: InputMaybe<ServiceTaskMainTypeFilter>
  onlyPartnerCustomers?: InputMaybe<BooleanFilter>
  type?: InputMaybe<ServiceTaskTypeFilter>
}

export type ServiceTaskListSortInput = {
  dueDate?: InputMaybe<SortDirection>
}

export enum ServiceTaskMainType {
  Automated = 'Automated',
  Custom = 'Custom'
}

export type ServiceTaskMainTypeFilter = {
  equals?: InputMaybe<ServiceTaskMainType>
  not_equals?: InputMaybe<ServiceTaskMainType>
}

export enum ServiceTaskType {
  AutomatedCallBack = 'AutomatedCallBack',
  AutomatedChangeDocument = 'AutomatedChangeDocument',
  AutomatedChangeUpgrade = 'AutomatedChangeUpgrade',
  AutomatedPoA = 'AutomatedPoA',
  Custom = 'Custom'
}

export type ServiceTaskTypeFilter = {
  equals?: InputMaybe<ServiceTaskType>
  in?: InputMaybe<Array<ServiceTaskType>>
  not_equals?: InputMaybe<ServiceTaskType>
  not_in?: InputMaybe<Array<ServiceTaskType>>
}

export type SetCustomerDocumentCheckInput = {
  checked: Scalars['Boolean']
  documentId: Scalars['Float']
}

export type SetDefaultLawyer = {
  lawyerId: Scalars['Int']
  productId?: InputMaybe<Scalars['Int']>
  setForAll?: InputMaybe<Scalars['Boolean']>
}

export type SingleProduct = {
  __typename?: 'SingleProduct'
  enabled: Scalars['Boolean']
  productType: SingleProductType
  purchase: Purchase
  topicId: Scalars['Float']
}

export enum SingleProductType {
  OneTimeRenovationClauseCheck = 'OneTimeRenovationClauseCheck',
  OneTimeRentalContractCheck = 'OneTimeRentalContractCheck',
  OneTimeUtilityBillCheck = 'OneTimeUtilityBillCheck'
}

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type SpringerCustomer = {
  __typename?: 'SpringerCustomer'
  firstName: Scalars['String']
  id: Scalars['Float']
  lastName: Scalars['String']
  phone: Scalars['String']
}

export type SpringerEntries = {
  __typename?: 'SpringerEntries'
  createdAt: Scalars['DateTime']
  customer: SpringerCustomer
  topicName: Scalars['String']
}

export type StringFilter = {
  equals?: InputMaybe<Scalars['String']>
  in?: InputMaybe<Array<Scalars['String']>>
  like?: InputMaybe<Scalars['String']>
  not_equals?: InputMaybe<Scalars['String']>
  not_in?: InputMaybe<Array<Scalars['String']>>
}

export enum StripSubscriptionStatus {
  Active = 'active',
  Canceled = 'canceled',
  Incomplete = 'incomplete',
  IncompleteExpired = 'incomplete_expired',
  PastDue = 'past_due',
  Trialing = 'trialing',
  Unpaid = 'unpaid'
}

export type StripeBlockingInvoice = {
  __typename?: 'StripeBlockingInvoice'
  amount?: Maybe<Scalars['String']>
  createdAt?: Maybe<Scalars['String']>
  id: Scalars['ID']
  productName?: Maybe<Scalars['String']>
}

export type StripeCustomerInvoice = {
  __typename?: 'StripeCustomerInvoice'
  amountDue: Scalars['Int']
  amountPaid: Scalars['Int']
  amountRemaining: Scalars['Int']
  createdAt: Scalars['String']
  customer: Customer
  invoiceNumber: Scalars['String']
  itFeeAmount?: Maybe<Scalars['String']>
  itFeeChargeId?: Maybe<Scalars['String']>
  lawyer?: Maybe<Lawyer>
  originalInvoiceId?: Maybe<Scalars['String']>
  paid?: Maybe<Scalars['Boolean']>
  paidAt?: Maybe<Scalars['DateTime']>
  product?: Maybe<Product>
  stripeInvoiceId: Scalars['String']
  stripeSubscriptionId?: Maybe<Scalars['String']>
  transferAmount?: Maybe<Scalars['String']>
  transferId?: Maybe<Scalars['String']>
  updatedAt: Scalars['String']
  void?: Maybe<Scalars['Boolean']>
}

export enum StripeInvoiceCollectionMethod {
  ChargeAutomatically = 'charge_automatically',
  SendInvoice = 'send_invoice'
}

export enum StripeInvoiceStatus {
  Draft = 'draft',
  Open = 'open',
  Paid = 'paid',
  Uncollectible = 'uncollectible',
  Void = 'void'
}

export type StripePaymentMethod = {
  __typename?: 'StripePaymentMethod'
  createdAt: Scalars['DateTime']
  expMonth?: Maybe<Scalars['Int']>
  expYear?: Maybe<Scalars['Int']>
  id: Scalars['ID']
  last4?: Maybe<Scalars['String']>
  type: Scalars['String']
}

export type StripeSubscription = {
  __typename?: 'StripeSubscription'
  createdAt: Scalars['DateTime']
  currentPeriodStartsAt?: Maybe<Scalars['DateTime']>
  endsAt?: Maybe<Scalars['DateTime']>
  id: Scalars['ID']
  nextPeriodStartsAt?: Maybe<Scalars['DateTime']>
  status: StripSubscriptionStatus
}

export type SubscriptionAllocationLawyerData = {
  __typename?: 'SubscriptionAllocationLawyerData'
  firstName: Scalars['String']
  id: Scalars['Float']
  lastName: Scalars['String']
}

export enum SubscriptionPartners {
  Adac = 'ADAC',
  Advocard = 'ADVOCARD',
  Allianz = 'ALLIANZ',
  Arag = 'ARAG',
  Auxilia = 'AUXILIA',
  Badische = 'BADISCHE',
  Concordia = 'CONCORDIA',
  Continentale = 'CONTINENTALE',
  Debeka = 'DEBEKA',
  Deurag = 'DEURAG',
  Devk = 'DEVK',
  Dmb = 'DMB',
  Ergo = 'ERGO',
  HukCoburg = 'HUK_COBURG',
  Immoscout24 = 'IMMOSCOUT24',
  Itzehoer = 'ITZEHOER',
  Klugo = 'KLUGO',
  Lvm = 'LVM',
  Mecklenburgische = 'MECKLENBURGISCHE',
  NeueRechtsschutz = 'NEUE_RECHTSSCHUTZ',
  Oerag = 'OERAG',
  Roland = 'ROLAND',
  RPlusV = 'R_PLUS_V',
  Vgh = 'VGH',
  Wgv = 'WGV',
  Wuerttembergische = 'WUERTTEMBERGISCHE'
}

export type SupportRequestCase = {
  __typename?: 'SupportRequestCase'
  assignedAgent?: Maybe<Admin>
  assignedAgentId?: Maybe<Scalars['Int']>
  customer: Customer
  customerId: Scalars['Int']
  id: Scalars['Int']
  lastTransitionAt?: Maybe<Scalars['DateTime']>
  messages: Array<SupportRequestMessage>
  state: SupportRequestCaseState
}

export enum SupportRequestCaseState {
  Closed = 'Closed',
  Deleted = 'Deleted',
  Open = 'Open'
}

export type SupportRequestCaseStateFilter = {
  equals?: InputMaybe<SupportRequestCaseState>
  in?: InputMaybe<Array<SupportRequestCaseState>>
  not_equals?: InputMaybe<SupportRequestCaseState>
  not_in?: InputMaybe<Array<SupportRequestCaseState>>
}

export type SupportRequestCasesCollection = {
  __typename?: 'SupportRequestCasesCollection'
  first?: Maybe<SupportRequestCase>
  items: Array<SupportRequestCase>
  last?: Maybe<SupportRequestCase>
  skip?: Maybe<Scalars['Int']>
  take?: Maybe<Scalars['Int']>
  total: Scalars['Int']
}

export type SupportRequestCasesListFilterInput = {
  assignedAgentId?: InputMaybe<IntFilter>
  createdAt?: InputMaybe<DateFilter>
  customerId?: InputMaybe<IntFilter>
  id?: InputMaybe<IntFilter>
  lastTransitionAt?: InputMaybe<DateFilter>
  state?: InputMaybe<SupportRequestCaseStateFilter>
  updatedAt?: InputMaybe<DateFilter>
}

export type SupportRequestCasesListSortInput = {
  createdAt?: InputMaybe<SortDirection>
  lastTransitionAt?: InputMaybe<SortDirection>
  updatedAt?: InputMaybe<SortDirection>
}

export type SupportRequestMessage = {
  __typename?: 'SupportRequestMessage'
  agent?: Maybe<Admin>
  agentId?: Maybe<Scalars['Int']>
  case?: Maybe<SupportRequestCase>
  caseId?: Maybe<Scalars['Int']>
  content: Scalars['JSON']
  createdAt: Scalars['DateTime']
  customer: Customer
  customerId: Scalars['Int']
  id: Scalars['Int']
  responseToId?: Maybe<Scalars['Int']>
  type: SupportRequestMessageType
  updatedAt: Scalars['DateTime']
}

export enum SupportRequestMessageType {
  Answer = 'Answer',
  Question = 'Question'
}

export type Template = {
  __typename?: 'Template'
  description?: Maybe<Scalars['String']>
  fields: Array<TemplateField>
  tags?: Maybe<Array<Scalars['String']>>
  title: Scalars['String']
  uid: Scalars['String']
}

export type TemplateCollection = {
  __typename?: 'TemplateCollection'
  fieldNames: Array<Scalars['String']>
  templates?: Maybe<Array<Template>>
  title: Scalars['String']
  uid: Scalars['String']
}

export type TemplateCollectionsCollection = {
  __typename?: 'TemplateCollectionsCollection'
  first?: Maybe<TemplateCollection>
  items: Array<TemplateCollection>
  last?: Maybe<TemplateCollection>
  skip?: Maybe<Scalars['Int']>
  take?: Maybe<Scalars['Int']>
  total: Scalars['Int']
}

export type TemplateCollectionsListFilterInput = {
  title?: InputMaybe<StringFilter>
  uid?: InputMaybe<StringFilter>
}

export type TemplateCollectionsListSortInput = {
  title?: InputMaybe<SortDirection>
  uid?: InputMaybe<SortDirection>
}

export type TemplateField = {
  __typename?: 'TemplateField'
  name: Scalars['String']
  text: Scalars['JSON']
}

export type TemplateFieldInput = {
  name: Scalars['String']
  text: Scalars['JSON']
}

export enum TenancyIssueStatus {
  Ongoing = 'Ongoing',
  PartlySolved = 'PartlySolved',
  Solved = 'Solved',
  Unresolved = 'Unresolved'
}

export type TenantProtection = {
  __typename?: 'TenantProtection'
  duration: Scalars['String']
  excess?: Maybe<Scalars['Int']>
  waitingTime: Scalars['Float']
}

export type ToggleGlobalFeatureInput = {
  enabled?: InputMaybe<Scalars['Boolean']>
  featureId: Scalars['Int']
}

export type ToggleUserGroupFeatureInput = {
  enabled: Scalars['Boolean']
  featureId: Scalars['Int']
  userGroupId: Scalars['Int']
}

export type Topic = {
  __typename?: 'Topic'
  createdAt: Scalars['DateTime']
  id: Scalars['Int']
  name: Scalars['String']
  updatedAt: Scalars['DateTime']
}

export type TransitionCourtCaseInput = {
  courtCaseUuid: Scalars['ID']
  newState: CourtCaseState
}

export type UnapproveMessageAsAdminInput = {
  id: Scalars['Float']
}

export type UpdateAdminInput = {
  email?: InputMaybe<Scalars['String']>
  firstName?: InputMaybe<Scalars['String']>
  id: Scalars['Int']
  isEmailConfirmed?: InputMaybe<Scalars['Boolean']>
  lastName?: InputMaybe<Scalars['String']>
  password?: InputMaybe<Scalars['String']>
}

export type UpdateCustomerContactInput = {
  address?: InputMaybe<OptionalAddressInput>
  email: Scalars['String']
  firstName?: InputMaybe<Scalars['String']>
  gender?: InputMaybe<Gender>
  id: Scalars['Float']
  lastName?: InputMaybe<Scalars['String']>
  mobilePhone?: InputMaybe<Scalars['String']>
  phone?: InputMaybe<Scalars['String']>
}

export type UpdateCustomerDocumentInput = {
  effectiveDeliveryTime?: InputMaybe<Scalars['Float']>
  id: Scalars['Float']
  name?: InputMaybe<Scalars['String']>
}

export type UpdateCustomerFeedbackAsAdminInput = {
  firstAttempt?: InputMaybe<Scalars['DateTime']>
  id: Scalars['Float']
  reachAttempt?: InputMaybe<Scalars['DateTime']>
  reachedAt?: InputMaybe<Scalars['DateTime']>
  secondAttempt?: InputMaybe<Scalars['DateTime']>
  serviceNote?: InputMaybe<Scalars['String']>
}

export type UpdateCustomerServiceTaskInput = {
  checked?: InputMaybe<Scalars['Boolean']>
  description?: InputMaybe<Scalars['String']>
  dueDate?: InputMaybe<Scalars['DateTime']>
  firstEmailSent?: InputMaybe<Scalars['DateTime']>
  title?: InputMaybe<Scalars['String']>
}

export type UpdateInkassoCaseInput = {
  inkassoCaseId: Scalars['String']
  state: InkassoCaseState
  stripeCustomerInvoiceId: Scalars['String']
}

export type UpdateInsuranceClaimInput = {
  expiresAt?: InputMaybe<Scalars['DateTime']>
  insuredEventDate?: InputMaybe<Scalars['DateTime']>
  insuredEventDescription?: InputMaybe<Scalars['String']>
  insuredPropertyAddress?: InputMaybe<Scalars['String']>
  insuredPropertyAffiliation?: InputMaybe<InsuredPropertyAffiliation>
  insuredPropertyType?: InputMaybe<InsuredPropertyType>
  notes?: InputMaybe<Scalars['String']>
  referenceNumber?: InputMaybe<Scalars['String']>
  topicIds?: InputMaybe<Array<Scalars['Int']>>
  uuid: Scalars['ID']
}

export type UpdateLawyerHolidayInput = {
  endDate?: InputMaybe<Scalars['DateTime']>
  id: Scalars['Int']
  isCompletelyUnavailable?: InputMaybe<Scalars['Boolean']>
  lawyerId: Scalars['Int']
  reason?: InputMaybe<LawyerHolidayReason>
  startDate?: InputMaybe<Scalars['DateTime']>
}

export type UpdateMessageTopicInput = {
  messageId: Scalars['Float']
  topicId: Scalars['Float']
}

export type UpdateTemplateInput = {
  description?: InputMaybe<Scalars['String']>
  fields: Array<TemplateFieldInput>
  tags?: InputMaybe<Array<Scalars['String']>>
  title?: InputMaybe<Scalars['String']>
  uid: Scalars['String']
}

export type UpgradePartnerSubscriptionInput = {
  customerId: Scalars['Int']
  from: PartnerProductType
  insuranceNumber: Scalars['String']
  partner: SubscriptionPartners
  to: PartnerProductType
}

export type UpsertCourtCaseAdminDeadlineInput = {
  adminDeadline?: InputMaybe<Scalars['DateTime']>
  courtCaseUuid: Scalars['ID']
}

export type UpsertCourtCaseAdminNoteInput = {
  adminNote: Scalars['String']
  courtCaseUuid: Scalars['ID']
}

export type UpsertCourtCaseCoverageRequestInput = {
  courtCaseUuid?: InputMaybe<Scalars['ID']>
  customerId?: InputMaybe<Scalars['ID']>
  insuranceCoverageState?: InputMaybe<CourtCaseCoverageState>
  selfPaymentAgreementDocumentId?: InputMaybe<Scalars['Int']>
  selfPaymentCoverageState?: InputMaybe<CourtCaseCoverageState>
  uuid?: InputMaybe<Scalars['ID']>
}

export enum UsedTemplatesOrChecklists {
  MultipleTimes = 'MultipleTimes',
  No = 'No',
  Once = 'Once',
  Unknown = 'Unknown'
}

export type UserGroup = {
  __typename?: 'UserGroup'
  description: Scalars['String']
  id: Scalars['Int']
  members: Array<UserGroupMember>
  name: Scalars['String']
}

export type UserGroupFeature = {
  __typename?: 'UserGroupFeature'
  enabled: Scalars['Boolean']
  featureId: Scalars['Int']
  userGroupId: Scalars['Int']
}

export type UserGroupMember = {
  __typename?: 'UserGroupMember'
  role: UserRole
  userId: Scalars['Int']
}

export type UserGroupMemberInput = {
  id: Scalars['Int']
  role: UserRole
}

export enum UserRole {
  Admin = 'ADMIN',
  Customer = 'CUSTOMER',
  Freemium = 'FREEMIUM',
  Lawyer = 'LAWYER'
}

export enum UserRoles {
  Admin = 'Admin',
  Customer = 'Customer',
  Freemium = 'Freemium',
  Lawyer = 'Lawyer'
}

export type UtilityBillAnalysisResult = {
  __typename?: 'UtilityBillAnalysisResult'
  checks: Checks
  outcome: Outcome
  servicePeriod: ServicePeriod
}

export type UtilityBillCheck = {
  __typename?: 'UtilityBillCheck'
  isCurrentAddress?: Maybe<Scalars['Boolean']>
  moveInDate?: Maybe<Scalars['String']>
  moveOutDate?: Maybe<Scalars['String']>
  sizeOfFlat?: Maybe<Scalars['Float']>
}

export enum UtilityBillCheckName {
  AdvancePayments = 'AdvancePayments',
  BenchmarkDeviations = 'BenchmarkDeviations',
  ContentRequirements = 'ContentRequirements',
  Deadlines = 'Deadlines',
  DistributionFormula = 'DistributionFormula',
  FormalRequirements = 'FormalRequirements',
  InvoiceItems = 'InvoiceItems',
  ServicePeriod = 'ServicePeriod'
}

export type UtilityBillResult = {
  __typename?: 'UtilityBillResult'
  description: Scalars['String']
  status: Scalars['String']
  statusLabel: Scalars['String']
  title: Scalars['String']
}

export type UtilityBillResults = {
  __typename?: 'UtilityBillResults'
  data: Array<UtilityBillResult>
  isMainTableFound: Scalars['Boolean']
}

export enum ValidGermanMobileNumberFormat {
  E164 = 'E164',
  YouCanBookMe = 'YouCanBookMe'
}

export type VerifyCoverageForInsuranceClaimInput = {
  uuid: Scalars['ID']
}

export type WriteLandlordInput = {
  emailSubject: Scalars['String']
  emailText: Scalars['String']
  hasSignature: Scalars['Boolean']
  landlordEmail: Scalars['String']
  templateName: Scalars['String']
}
